// 商品详情页面
<template>
	<div>
		<!-- <StoreHeaderCat ref="headercat" @updateFllow="updateFllow" /> -->
		<div class="sld_goods_detail">
			<!-- 内容区顶部固定 start -->
			<div class="contain_con" v-if="containCon">	
				<div class="contain_content">
					<div class="goods_description_title flex_row_start_center">					
						<div class="cursor_pointer goods_tab_item" :class="{ description_active: goodsDesctionType == 'detail' }"
							@click="goodsDescType('detail')">{{ L['商品详情'] }}</div>
						<div class="cursor_pointer goods_tab_item" :class="{
							description_active: goodsDesctionType == 'specParam'
						}" @click="goodsDescType('specParam')">{{ L['规格参数'] }}</div>
						<div class="cursor_pointer goods_tab_item comment" :class="{
							description_active: goodsDesctionType == 'evaluate'
						}" @click="goodsDescType('evaluate')">
							 <div>{{ L['商品评价'] }}</div>
							 <div class="count">({{ goodsCommentsInfo.data &&
goodsCommentsInfo.data.commentsCount > 0 ? goodsCommentsInfo.data.commentsCount : '0' }})
							</div>
						</div>
						<div class="cursor_pointer goods_tab_item"  style="display: none;"  :class="{
							description_active: goodsDesctionType == 'service'
						}" @click="goodsDescType('service')">{{ L['商品服务'] }}</div>
						
					</div>				
				</div>				
			</div>
			<!-- 内容区顶部固定 end -->
			
			<div class="goods_detail_content" v-if="goodsDetail.data">
				<!-- 商品所属分类  start-->
				<div class="goods_about_con flex_row_start_center">					
						<div class="goods_classify ">
							<span >
								<router-link style="color: #000000;"  to="/">
									首页</router-link>
							</span>
							
							<span v-for="(item, index) in goodsDetail.data.categoryPath" :key="index">
								<i> > </i>
								<router-link   :to="`/goods/list?categoryId=${goodsDetail.data.categoryIdPath[index]
									}&g=${index + 1}${index > 0
										? '&pid=' + goodsDetail.data.categoryIdPath[index - 1]
										: '&pid=0'
									}`
									">
									{{ item }}</router-link>
								<!-- <i> > </i> -->
							</span>
							<!-- <span style="color: #888E98;">{{
								goodsDetail.data.goodsName
							}}</span> -->
						
						
					</div>
				</div>
				<!-- 商品所属分类 end-->
				<!-- 商品主要信息 start -->
				<div class="main_con">
					<!-- 商品相关 start -->
					<div class="goods_des">
						<!-- 商品图片列表 start -->
						<div class="goods_des_left">
							<!-- 商品图片列表 start -->
							<div :class="{
								goods_picture_con: true,
								flex_column_between_center: true,
								skeleton_goods_picture_con: firstLoading
							}" v-if="goodsDetail.data.defaultProduct && goodsDetail.data.defaultProduct.goodsPics && goodsDetail.data.defaultProduct.goodsPics.length > 0">
								
								<div class="showPic_arrow" :class="{noShow:goodsDetail.data.defaultProduct.goodsPics.length<=ShowPicMaxNum}">
									<img  v-if='curShowPicIndex == 0' class="ni_arraw_up disable" src="@/assets/goods/up_arraw_gray.png" alt=""
										@click="switchDefaultImage('left')"/>
									<img v-else class="ni_arraw_up" src="@/assets/goods/up_arraw.png" alt=""
										@click="switchDefaultImage('left')"/>	
								</div>
								
								<div class="show_box">
									<ul class="goods_picture_list flex_column_start_center" ref="goodsPictureList">
										<li v-for="(goodsImgItem, goodsImgIndex) in goodsDetail.data
											.defaultProduct.goodsPics" :key="goodsImgIndex" class="goods_img"
											:class="{ goods_img_active: currentDefaultImage == goodsImgIndex }"
											@click="selectDefaultImage(goodsImgItem, goodsImgIndex)"
											@mouseover="selectDefaultImage(goodsImgItem, goodsImgIndex)">
											<div class="goods_image" :style="{
												backgroundImage: 'url(' + goodsImgItem + ')'
											}"></div>
										</li>
									</ul>
								</div>
								<div class="showPic_arrow" :class="{noShow:goodsDetail.data.defaultProduct.goodsPics.length<=ShowPicMaxNum}">
									<img  v-if='curShowPicIndex ==
										goodsDetail.data.defaultProduct.goodsPics.length - ShowPicMaxNum' class="ni_arraw_down disable" src="@/assets/goods/down_arraw_gray.png" alt=""
										@click="switchDefaultImage('right')"/>
									<img v-else class="ni_arraw_down" src="@/assets/goods/down_arraw.png" alt=""
										@click="switchDefaultImage('right')"/>	
								</div>
								
							</div>
							<!-- 商品图片列表 end -->
							<!-- 商品放大镜效果 start-->
							<div class="goods_main">
								<div class="goods_main_picture">
									<div class="preview-box" @mousemove="move($event)" @mouseleave="out($event)" @mouseenter="enter($event)"
										ref="previewBox">
										<div class="imageBorder" :class="{
											default_image: true,
											skeleton_default_image: firstLoading
										}" :style="{ backgroundImage: 'url(' + defaultImage + ')' }">
											<template v-if="currentDefaultImage == -1 && goodsDetail.data.goodsVideo">
												<video  controls muted playsinline="playsinline" class="video  imageBorder default_image" :poster="defaultImage" autoplay
													ref="video">
													<source :src="goodsDetail.data.goodsVideo" type="video/mp4" />
												</video>
												<img class="video_close_icon" @click="closeVideo"    src="@/assets/goods/close_white.png"/>
											</template>
										</div>
										<div class="v_btn" v-if="currentDefaultImage == 0 && goodsDetail.data.goodsVideo
											">
											<img src="@/assets/goods/playV.png" alt="" @click="playV" />
										</div>
										<!-- 遮罩 start-->
										<div class="mask" ref="maskBox" v-show="maskShow"></div>
										<!-- 遮罩 end -->
										
									</div>
									<!-- 右侧的放大后的图片 start -->
									<div class="goods_picture_big" style="border:1px solid #eee" ref="zoomBox" v-show="maskShow">
										<div class="default_image_big" :style="{ backgroundImage: 'url(' + defaultImage + ')' }"
											ref="pictureBig">
										</div>
									</div>
									<!-- 右侧的放大后的图片 end -->
								</div>
								<!-- 商品放大镜效果 end -->
								<!-- 商品操作 start -->
								<div class="some_operate flex_row_between_center">
									<div class="op_item_contanier flex_row_start_center" @click="collectGoods">
										<img class="op_item_icon" v-if="goodsDetail.data.followGoods"  src="@/assets/goods/favatared.png"/>
										<img class="op_item_icon" v-else  src="@/assets/goods/favatar.png"/>
										<div class="op_item_txt">收藏</div>
									</div>
									<!-- <div class="op_item_contanier flex_row_start_center">
										<img class="op_item_icon" src="@/assets/goods/check_sel.png"/>
										<div class="op_item_txt">添加对比</div>
									</div> -->
									<div class="op_item_contanier app_buy flex_row_start_center">
										<img class="op_item_icon" src="@/assets/goods/qrcode.png"/>
										<div class="op_item_txt">手机app下单福利</div>
										<div class="app_buy_qrcode_contaner flex_row_center_center ">
											<img class="app_buy_qrcode" src="@/assets/goods/code_app.png"/>
										</div>
										
									</div>
									<div class="op_item_contanier wx_buy flex_row_start_center">
										<img class="op_item_icon" src="@/assets/goods/qrcode.png"/>
										<div class="op_item_txt">扫码进小程序</div>
										<div class="wx_buy_qrcode_contaner flex_row_center_center " id="wx_buy_qrcode_contaner">
											<img class="wx_buy_qrcode" src="@/assets/goods/code_wxm.png"/>
										</div>
									</div>
									<!-- 为了屏蔽对比后显示正常，移动到这里， -->
									<div class="op_item_contanier flex_row_start_center" style="opacity: 0;">
										<img class="op_item_icon" src="@/assets/goods/check_sel.png"/>
										<div class="op_item_txt">添加对比</div>
									</div>
								</div>
							</div>						
							<!-- 商品操作 end  -->
						</div>
						<!-- 商品图片列表 end -->
						<!-- 商品详细信息 start -->
						<div class="m_item_inner">
							<div class="item_info">

                                <div class="activity_type_time flex_row_start_center" v-if="hasAct">
									<!-- 0元预约 -->
									<div class="freeOrder act_pannel" v-if="promotionType==freeOrder" >
										<div class="act_content flex_row_start_center">
											<div class="act_type flex_row_center_center noStart" v-if='freeOrderInfo.data.type==1'>
												<img class="act_img" src="@/assets/goods/alarm_simple.png"/>
												<div class="act_title">0元预约</div>
											</div>
											<div class="act_type flex_row_center_center" v-else>
												<img class="act_img" src="@/assets/goods/alarm_yellow.png"/>
												<div class="act_title">0元预约</div>
											</div>
											
											<div class="act_tip flex_row_center_center"  v-if="freeOrderInfo.data.isStart">
												<div class="tip">{{freeOrderInfo.data.type==1?'距离活动开始还剩：':'距离活动结束仅剩：'}}</div>
												<div class="day" v-show="actCountDownDay != '00'">{{ actCountDownDay }}天</div>
												<div class="time">{{ actCountDownHr }}</div>
												<div class="time_tips">:</div>
												<div class="time">{{ actCountDownMin }}</div>
												<div class="time_tips">:</div>
												<div class="time">{{ actCountDownSec }}</div>
											</div>
																					
										</div>					
									</div>
									<!-- 限时抢购 -->
									<div class="flashSale act_pannel" v-if="promotionType==flashSale" >
										<div class="act_content flex_row_start_center">
											<div class="act_type flex_row_center_center">
												<img class="act_img" src="@/assets/goods/alarm.png"/>
												<div class="act_title">限时抢购</div>
											</div>
											<div class="act_tip flex_row_center_center">
												<div class="tip">距活动结束仅剩：</div>
												<div class="day" v-show="actCountDownDay != '00'">{{ actCountDownDay }}天</div>
												<div class="time">{{ actCountDownHr }}</div>
												<div class="time_tips">:</div>
												<div class="time">{{ actCountDownMin }}</div>
												<div class="time_tips">:</div>
												<div class="time">{{ actCountDownSec }}</div>
											</div>																					
										</div>					
									</div>
									<!-- 预售 -->
									<div class="preSel act_pannel" v-if="promotionType==preSel" >
										<div class="act_content flex_row_start_center">
											<div class="act_type flex_row_center_center">
												<img class="act_img" src="@/assets/goods/alarm_yellow.png"/>
												<div class="act_title">预售</div>
											</div>
											<div class="act_tip flex_row_center_center">
												<div class="tip">距活动结束还剩：</div>
												<div class="day" v-show="actCountDownDay != '00'">{{ actCountDownDay }}天</div>
												<div class="time">{{ actCountDownHr }}</div>
												<div class="time_tips">:</div>
												<div class="time">{{ actCountDownMin }}</div>
												<div class="time_tips">:</div>
												<div class="time">{{ actCountDownSec }}</div>
											</div>																					
										</div>					
									</div>
									
									<div class="rule_info flex_row_start_center cursor_pointer">
										<img class="rule_icon" src="@/assets/goods/info_icon.png"/>
										<div class="rule_title">活动规则</div>
										<div class="rule_content_container">
											<div class="rule_content">
												<div class="rule_html" v-html="ruleInfo.data.content">
												</div>
											</div>
										</div>
										
									</div>
									
								</div>

								<div :class="{
									detaile_name: true,
									skeleton_detaile_name: firstLoading
								}">
									{{goodsDetail.data.goodsName}} {{curSpecValue}}
								</div>
								<div :class="{ p_ad: true, skeleton_p_ad: firstLoading }" v-if="goodsDetail.data.goodsBrief">
									{{ goodsDetail.data.goodsBrief }}
								</div>
								
								<div class="adver flex_row_start_center" v-if="goodsDetail.data.frontGoodAdvertisement&&goodsDetail.data.frontGoodAdvertisement.adLink" >
									<div class="adver_content">{{ goodsDetail.data.frontGoodAdvertisement.adName}}</div>
									<div class="cursor_pointer adver_view" @click="onAderView(goodsDetail.data.frontGoodAdvertisement.adLink)">点击查看></div>									
								</div>
								<!-- price start -->
								<div class="price_pannel flex_row_start_end">
									<!-- 0元预约 -->
									<template v-if="promotionType==freeOrder">
										<div class="sell_price flex_row_start_end" >
											<template v-if="freeOrderInfo.data.isShowPresalePrice==0">
												<div class="price_int">{{L['待发布']}}</div>
											</template>
											<template v-else-if='freeOrderInfo.data.priceType==1'>
												<div class="unit">{{ L['预约价 ¥'] }}</div>
												<div class="price_int">{{freeOrderInfo.data.promotionPrice}}</div>
											</template>
											<template v-else-if='freeOrderInfo.data.priceType==2'>
												<div class="unit">{{L['到手价 ¥'] }} 
													<div class="yugu flex_row_center_center">预估</div>
												</div>
												<div class="price_int">{{freeOrderInfo.data.promotionPrice}}</div>
											</template>
										</div>
										<div class="original_price" v-if="freeOrderInfo.data.isShowPresalePrice!=0">
											{{ L['¥'] }}
											{{freeOrderInfo.data.productPrice}}
										</div>	
									</template>
									<!-- 限时抢购 -->
									<template v-else-if="promotionType==flashSale">
										<div class="sell_price flex_row_start_end" >
											 <template v-if='!flashSaleInfo.data.receivedCouponId'>
												<div class="unit">{{L['抢购价 ¥'] }}</div>
												<div class="price_int">{{flashSaleInfo.data.flashSalePrice}}</div>
														
											  </template>
											  <template v-else>
												<div class="unit">{{L['到手价 ¥'] }} 
													<div class="yugu flex_row_center_center">预估</div>
												</div>
												<div class="price_int">{{flashSaleInfo.data.receivedPrice }}</div>
											
											   </template>							   
										</div>
										<div class="original_price">
											{{ L['¥'] }}
											{{flashSaleInfo.data.productPrice}}
										</div>	
									</template>
									<!-- 预售 -->
									<template v-else-if="promotionType==preSel">
										<div class="sell_price flex_row_start_end" >
											 <template v-if='!preSelInfo.data.receivedCouponId'>
												<div class="unit">{{L['预售价 ¥'] }}</div>
												<div class="price_int">{{preSelInfo.data.presellPrice}}</div>
														
											  </template>
											  <template v-else>
												<div class="unit">{{L['到手价 ¥'] }} 
													<div class="yugu flex_row_center_center">预估</div>
												</div>
												<div class="price_int">{{preSelInfo.data.receivedPrice }}</div>
											
											   </template>							   
										</div>
										<div class="original_price">
											{{ L['¥'] }}
											{{preSelInfo.data.productPrice}}
										</div>	
									</template>
									<!-- 首单专享 -->
									<template v-else-if="promotionType==firstVIP">
										<div class="sell_price flex_row_start_end" >											
											<div class="unit">{{L['首单价¥'] }}</div>
											<div class="price_int">{{defaultProduct.data.firstBuyPrice}}</div>	
										</div>
										<div class="original_price">
											{{ L['¥'] }}
											{{defaultProduct.data.productPrice}}
										</div>	
									</template>	
									<!-- 正常 -->
									<template v-else-if='canShowBottomRBtn'>
										<div class="sell_price flex_row_start_end" v-if="specNoActPrice">
											<template v-if="!specNoShowReceivedPrice">
												<div class="unit">{{ L['¥'] }} </div>
												<div class="price_int">{{specNoActPrice }}</div>
												
											</template>
											<template v-else>
												<div class="unit">{{L['到手价 ¥'] }} 
													<div class="yugu flex_row_center_center">预估</div>
												</div>
												<div class="price_int">{{specNoCouponReceivedPrice.data.receivedPrice }}</div>
											
											 </template>	
											
										</div>
										<div class="original_price" v-if="specNoShowReceivedPrice">
											{{ L['¥']}}
											{{specNoActPrice}}
										</div>
																				
										<!-- <div class="jj_notify_txt flex_row_center_center"  v-if="!specNoShowReceivedPrice"  @click="showNoDoToast">{{L['降价通知']}}</div> -->
										
									</template>
									
								</div>
																
								<!-- price end -->
								<!-- 赠品 start -->
								<template v-if="giftInfo.data&&giftInfo.data.length>0">
									<div class="common_title">赠品</div>
									<div class="gift_pannel flex_row_start_center">
										<div class="gift_item flex_column_center_center"  @click="goGoodsDetail(gItem.productId)" v-for="(gItem,gIndex) in giftInfo.data" :key='gIndex'>
											<div class="gItem_icon_container">
												<img class="gItem_icon" :src="gItem.mainImageUrl"/>
											</div>
											
											<div class="gItem_num">数量：{{gItem.count}}</div>
										</div>
									</div>
								</template>
								<!-- 赠品 end -->	
								<!-- 优惠信息 start -->
								<template v-if='interFreeShowList.data.length>0||showCoupons.data.length>0'>
									<div class="common_title">优惠信息</div>
									<div class="yhInfo_pannel flex_row_start_center">
										<template v-if='interFreeShowList.data.length>0'>
											<div class="yh_infos" v-for="(freeItem,freeIndex) in interFreeShowList.data.slice(0,5)"   :key="freeIndex" >{{freeItem}}</div>
										</template>	
										<template v-if='5-interFreeShowList.data.length>0'>
											<div class="yh_infos" v-for="(coupItem,coupIndex) in showCoupons.data.slice(0,5-interFreeShowList.data.length)"  :key="coupItem">{{coupItem}}</div>
										</template>
										
										<div class="yh_infos more" style="display: none;"   @click="showNoDoToast">更多 ></div>
									</div>
								</template>
								<!-- 优惠信息 end -->
								<div class="info_sep"></div>
								<!-- 服务承诺start -->
								<div class="service_pannel flex_row_start_center" v-if='services.data.length>0&&!firstLoading'>
									<div class="service_item " v-for="(sevItem,sevIndex) in services.data" :key="sevIndex">
										· {{sevItem}}
									</div>
								</div>	
								<!-- 服务承诺end -->
								<!-- 更多系列 start-->
								<template v-if='goodsDetail.data.goodsGroupList&&goodsDetail.data.goodsGroupList.length>0'>
									<div class="common_title big">更多系列</div>
									<div class="spec_list flex_row_between_center">
										<div class="spec_value flex_row_center_center " :class="{'selected':spu_item.goodsId==goodsDetail.data.goodsId}"
										@click="onSpuGroupClick(spu_item)" 	
										 v-for="(spu_item,spu_index) in goodsDetail.data.goodsGroupList" :key="spu_item" >
											<div class="spec_content overflow_ellipsis_two">{{spu_item.goodsDisplayName}}</div>										
										</div>
									</div>
								</template>	
								<!-- 更多系列 end-->
								<!-- 选择配置start -->
								<template v-if='goodsDetail.data.productSpecs&&goodsDetail.data.productSpecs.length>0'>
									<div class="common_title big">选择配置</div>
									<div class="spec_list flex_row_between_center">
										<!-- <div class="spec_value flex_row_center_center " :class="{'disable':spec_item.stock==0,'selected':curSpecIndex==spec_index}" -->
										<div class="spec_value flex_row_center_center " :class="{'selected':curSpecIndex==spec_index}"
										@click="selectSpecVal(spec_item,spec_index)" 	
										 v-for="(spec_item,spec_index) in goodsDetail.data.productSpecs" :key="spec_index" >
											<div class="spec_content overflow_ellipsis_two">{{spec_item.specValues}}</div>										
										</div>
									</div>
									
								</template>	
								<!-- 选择配置end -->
								<!-- 增值服务start -->
								<template v-if='incrServiceInfo.data.length>0'>
									<div v-for="(sev_group_item,sev_group_index ) in incrServiceInfo.data" :key="sev_group_index">
										<div class="sev_content_title flex_row_between_center" :class="{ noFirst:sev_group_index>0}">
											<div class="title">{{sev_group_item.increaseGroupName}}</div>
											<div class="learn_more" @click="onIncrSerDetailTap(sev_group_item.commodityList[sev_group_item.selIndex])"  v-if="sev_group_item.selIndex>=0"  >
												了解服务详情>
											</div>								
										</div>
										<div class="sev_list flex_row_between_center">
											<div class="sev_item flex_row_center_center " :class="{active:sev_index==sev_group_item.selIndex}"  @click="onIncrServTap(sev_group_index,sev_index)" v-for="(sev_item,sev_index) in sev_group_item.commodityList" :key="sev_index" >
												<div class="sev_value overflow_ellipsis ">{{sev_item.productShortTitle}}</div>
												<div class="sev_price">¥{{sev_item.productActivityPrice}}</div>
												<div class="sev_marketPrice" v-if="sev_item.productPrice">¥{{sev_item.productPrice}}</div>
												<div class="sev_benifit flex_row_center_center" v-if='sev_item.interestPoint'>{{sev_item.interestPoint}}</div>
											</div>
										</div>
									</div>
								</template>								
								<!-- 增值服务end -->
								<!-- 推荐搭配start -->
								<template v-if='incrPriceShopInfo.data.list&&incrPriceShopInfo.data.list.length>0'>
									<div class="common_title tjdp_title">推荐搭配</div>
									<div class="tjdp_list flex_row_between_start">
										<div class="tjdp_item "   v-for="(tjdp_item,tjdp_index) in incrPriceShopInfo.data.list" :key="tjdp_index">
											<div class="tjdp_top flex_row_center_start" :class="{sel:tjdp_item.sel}" @click="ontjdpContentTap(tjdp_item)">
												<div class="tjdp_img_container">
													<img class="tjdp_img" :src="tjdp_item.mainImageUrl" />
												</div>
												
												<div class="tjdp_name_price flex_column_between_start">
													<div class="tjdp_name overflow_ellipsis_two">{{tjdp_item.productShortTitle}} </div>
													<div>
														<div class="tjdp_price flex_row_start_center">
															<div class="price_normal">¥{{tjdp_item.productIncreasePrice.toFixed(2)}}</div>
															<img class="price_save" src="@/assets/goods/save_iocn.png"/>
															<div class="price_tip">{{tjdp_item.savePrice}}</div>
														</div>
														<div class="price_market">¥{{tjdp_item.productPrice.toFixed(2)}}</div>
													</div>
												</div>
												<img  class="tjdp_check"  @click.stop="onIncPriceShopTap(tjdp_index)"   src="@/assets/goods/check_sel.png"   v-if='tjdp_item.sel'/>
												<img class="tjdp_check" @click.stop="onIncPriceShopTap(tjdp_index)"    src="@/assets/goods/check_unsel.png"  v-else/>
											</div>
											<div class="tjdp_num flex_row_start_center" v-if='tjdp_item.sel'>
												<div class="num_tip">请确认数量</div>
												<div  @click="tjdpEditNum(tjdp_index,'reduce')" class='add_redue' :class="{ no_edit: tjdp_item.num == 1 }">
													<div class="jian symbol">-</div>
													
												</div>
												<input type="number" v-model="tjdp_item.num" @input="tjdpEditNum(tjdp_index,'edit', $event)" @blur="tjdpEditNum(tjdp_index,'edit', $event)"
													cursor-spacing="0" :cursor="tjdp_item.num.toString().length" maxlength="5" />
												<div @click="tjdpEditNum(tjdp_index,'add')"  class='add_redue' :class="{ no_edit: tjdp_item.noEdit }">
													<!-- <div class="add_hen symbol"></div>
													<div class="add_shu symbol"></div> -->
													<div class="add symbol">+</div>
												
												</div>
											</div>
										</div>
										<div class="tjdp_stub" v-for="(tjdpStub_item,tjdpStub_index) in incrPriceShopInfo.data.stubNum" :key="tjdpStub_index"></div>
									</div>
									
								</template>
								<!-- 推荐搭配end -->								
								<!-- 价格spec start -->
								<div class="total_price_spec" v-if='promotionType!=freeOrder&&promotionType!=preSel&&!firstLoading'>
									<div class="total_price flex_row_start_end" >
										<div class="tp_title"><span>总计</span><span class="tp_sign">￥</span></div>
										<div class="tp_num">{{totalPrice}}</div>
									</div>
									<div class="cur_spec_num">已选{{curSpecValue}} x{{currentSpecNum}}</div>
								</div>
								<!-- 价格spec end -->
								<div class="num_deal_pannel flex_row_start_center" v-if='!firstLoading'>
									<template v-if="platformSupport">
										<div class="buy_num flex_row_start_center">
											<div  @click="editNum('reduce')" class='add_redue' :class="{ no_edit: currentSpecNum == 1 }">
												<div class="jian symbol">-</div>
											</div>
											<input type="number" v-model="currentSpecNum"  @input="editNum('edit', $event)" @blur="editNum('edit', $event)"
												cursor-spacing="0" :cursor="currentSpecNum.toString().length" maxlength="5" />
											<div @click="editNum('add')"  class='add_redue' :class="{ no_edit: noEdit }">
												<div class="add symbol">+</div>
											</div>
										</div>
										<template v-if="canShowBottomRBtn">
											<!--商品已下架 start -->
											<div class="action_btn_group" v-if="goodsDetail.data.state != 3">
													<div class="action_btn large_btn flex_row_center_center">{{
												L['商品已下架']
													}}</div>
												</div>
												<!--商品已下架 end -->
												<!--库存不足start -->
												<div class="action_btn_group" v-else-if="
												defaultProduct &&
												defaultProduct.data.productStock == 0&&promotionType!=freeOrder
											">
													<div class="action_btn large_btn flex_row_center_center" @click="doStockHasTap">
														{{ L['到货通知'] }}
													</div>
												</div>
												<!--库存不足 end -->											
											<!-- 0元预约 -->
											<template v-else-if="promotionType==freeOrder">													
												<div class="action_btn_group flex_row_center_center" v-if="!freeOrderInfo.data.isBooking">
													<div class="action_btn large_btn flex_row_center_center" @click='onFreeOrderTap(freeOrderInfo.data.type)'>{{freeOrderInfo.data.type==1?
													L['开始提醒']: L['预约']
													}}</div>
												</div>
												<div class="action_btn_group flex_row_center_center" v-else>
													<div class="action_btn large_btn hasDo flex_row_center_center">{{
													L['已预约']
													}}</div>
												</div>
											</template>
											<!-- 限时抢购 -->
											<template v-else-if="promotionType==flashSale">
																														
													<div class="action_btn_group flashSale flex_row_center_center">
														<template v-if="goodsDetail.data.canAddCart">	
															<div class="cart_btn flex_row_center_center"  @click="addCart">
																<img class="cart_icon" src="@/assets/goods/cart_white_icon.png"/>
															</div>
															<div class="action_btn middle flex_row_center_center"  @click="goBuy">
																{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即抢购'] }}
															</div>
														</template>
														<div class="action_btn middle action_long  flex_row_center_center" v-else  @click="goBuy">
															{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即抢购'] }}
														</div>
													</div>
												
											</template>
											<!-- 预售 -->
											<template v-else-if="promotionType==preSel">										
												<div class="action_btn_group" v-if="preSelInfo.data.type==1">
													<div class="action_btn large_btn flex_row_center_center dj" v-if='!preSelInfo.data.isPay' @click="goBuy">
														<div class="dj_title">支付定金</div>
														<div class="dj_num">定金 ¥ {{preSelInfo.data.firstMoney}}</div>
													</div>
													<div class="action_btn large_btn flex_row_center_center hasDo" v-else>
														已支付定金
													</div>
												</div>
												<div class="action_btn_group" v-else>
													<div class="action_btn large_btn flex_row_center_center" v-if='!preSelInfo.data.isPay' @click="showNoDoToast">
													支付全款							
													</div>
													<div class="action_btn large_btn flex_row_center_center hasDo" v-else>
														已支付全款
													</div>
												</div>
											</template>	
											<!-- 首单专享 -->
											<template v-else-if="promotionType==firstVIP">					
												<div class="action_btn_group" >
													<div class="action_btn large_btn flex_row_center_center" @click="goBuy">
														立即购买
													</div>
												</div>
											</template>
											<!-- 正常商品 start -->
											<template v-else>
												<!--商品已下架 start -->
												<div class="action_btn_group" v-if="goodsDetail.data.state != 3">
													<div class="action_btn large_btn flex_row_center_center">{{
												L['商品已下架']
													}}</div>
												</div>
												<!--商品已下架 end -->
												<!--库存不足start -->
												<div class="action_btn_group" v-else-if="
												defaultProduct &&
												defaultProduct.data.productStock == 0
											">
													<div class="action_btn large_btn flex_row_center_center" @click="doStockHasTap">
														{{ L['到货通知'] }}
													</div>
												</div>
												<!--库存不足 end -->
												
												<div class="action_btn_group flex_row_center_center" v-else>
													<template v-if="goodsDetail.data.canAddCart">												
														<div class="cart_btn  flex_row_center_center" @click="addCart">
															<img class="cart_icon" src="@/assets/goods/cart_icon.png"/>
														</div>
														<div class="action_btn middle flex_row_center_center"  @click="goBuy">
															{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即购买'] }}
														</div>
													</template>	
													<div class="action_btn middle action_long flex_row_center_center" v-else @click="goBuy">
														{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即购买'] }}
													</div>

												</div>											
											</template>										
										</template>
									</template>
									<div class="platformNoSupport" v-else>
										<div class="wx_buy_no_support" id="wx_buy_no_support">
											<img class="wx_buy_no_qrcode" src="@/assets/goods/code_wxm.png"/>
										</div>
										<div class="no_tip">
											<div class="no_tip_txt">仅支持小程序购买</div>
											<div class="no_tip_txt">扫一扫，立即下单</div>
										</div>										
									</div>
								</div>
							</div>
							
							<!-- 悬浮小框  start-->
							<div class="float_sBox " id='float_sBox' v-show="floatMinBoxShow>0"  :style="{ '--translate-x': floatMinBoxTransX + 'px' }"   style="transform: none; visibility: visible;">
								
								<div class="fs_top flex_row_start_center">
									<img class="fs_mainImg"  v-if='goodsDetail.data.productSpecs'   :src="goodsDetail.data.productSpecs[curSpecIndex].mainImage">
									<!-- 价格 优惠信息start -->
									<div class="fs_price_fav">
										<div class="fs_price flex_row_start_end">
											<!-- 0元预约 -->
											<template v-if="promotionType==freeOrder">
												<div class="sell_price flex_row_start_end" >
													<template v-if="freeOrderInfo.data.isShowPresalePrice==0">
														<div class="price_int">{{L['待发布']}}</div>
													</template>
													<template v-else-if='freeOrderInfo.data.priceType==1'>
														<div class="unit">{{ L['预约价 ¥'] }}</div>
														<div class="price_int">{{freeOrderInfo.data.promotionPrice}}</div>
													</template>
													<template v-else-if='freeOrderInfo.data.priceType==2'>
														<div class="unit">{{L['到手价 ¥'] }} 
															<div class="yugu flex_row_center_center">预估</div>
														</div>
														<div class="price_int">{{freeOrderInfo.data.promotionPrice}}</div>
													</template>
												</div>
												<div class="original_price" v-if="freeOrderInfo.data.isShowPresalePrice!=0">
													{{ L['¥'] }}
													{{freeOrderInfo.data.productPrice}}
												</div>	
											</template>
											<!-- 限时抢购 -->
											<template v-else-if="promotionType==flashSale">
												<div class="sell_price flex_row_start_end" >
													 <template v-if='!flashSaleInfo.data.receivedCouponId'>
														<div class="unit">{{L['抢购价 ¥'] }}</div>
														<div class="price_int">{{flashSaleInfo.data.flashSalePrice}}</div>
																
													  </template>
													  <template v-else>
														<div class="unit">{{L['到手价 ¥'] }} 
															<div class="yugu flex_row_center_center">预估</div>
														</div>
														<div class="price_int">{{flashSaleInfo.data.receivedPrice }}</div>
													
													   </template>							   
												</div>
												<div class="original_price">
													{{ L['¥'] }}
													{{flashSaleInfo.data.productPrice}}
												</div>	
											</template>
											<!-- 预售 -->
											<template v-else-if="promotionType==preSel">
												<div class="sell_price flex_row_start_end" >
													 <template v-if='!preSelInfo.data.receivedCouponId'>
														<div class="unit">{{L['预售价 ¥'] }}</div>
														<div class="price_int">{{preSelInfo.data.presellPrice}}</div>
																
													  </template>
													  <template v-else>
														<div class="unit">{{L['到手价 ¥'] }} 
															<div class="yugu flex_row_center_center">预估</div>
														</div>
														<div class="price_int">{{preSelInfo.data.receivedPrice }}</div>
													
													   </template>							   
												</div>
												<div class="original_price">
													{{ L['¥'] }}
													{{preSelInfo.data.productPrice}}
												</div>	
											</template>
											<!-- 首单专享 -->
											<template v-else-if="promotionType==firstVIP">
												<div class="sell_price flex_row_start_end" >											
													<div class="unit">{{L['首单价¥'] }}</div>
													<div class="price_int">{{defaultProduct.data.firstBuyPrice}}</div>	
												</div>
												<div class="original_price">
													{{ L['¥'] }}
													{{defaultProduct.data.productPrice}}
												</div>	
											</template>	
											<!-- 正常 -->
											<template v-else-if='canShowBottomRBtn'>
												<div class="sell_price flex_row_start_end" v-if="specNoActPrice">
													<template v-if="!specNoShowReceivedPrice">
														<div class="unit">{{ L['¥'] }} </div>
														<div class="price_int">{{specNoActPrice }}</div>
														
													</template>
													<template v-else>
														<div class="unit">{{L['到手价 ¥'] }} 
															<div class="yugu flex_row_center_center">预估</div>
														</div>
														<div class="price_int">{{specNoCouponReceivedPrice.data.receivedPrice }}</div>
													
													 </template>	
													
												</div>
												<div class="original_price" v-if="specNoShowReceivedPrice">
													{{ L['¥']}}
													{{specNoActPrice}}
												</div>
																						
												<!-- <div class="jj_notify_txt flex_row_center_center"  v-if="!specNoShowReceivedPrice"  @click="showNoDoToast">{{L['降价通知']}}</div> -->
												
											</template>
										</div>
										<div class="yhInfo_pannel  flex_row_start_center"  v-if='interFreeShowList.data.length>0||showCoupons.data.length>0'>
											<template v-if='interFreeShowList.data.length>0'>
												<div class="yh_infos" v-for="(freeItem,freeIndex) in interFreeShowList.data.slice(0,1)"   :key="freeIndex" >{{freeItem}}</div>
											</template>	
											<template v-if='1-interFreeShowList.data.length>0'>
												<div class="yh_infos" v-for="(coupItem,coupIndex) in showCoupons.data.slice(0,1-interFreeShowList.data.length)"  :key="coupItem">{{coupItem}}</div>
											</template>
											
											<div class="yh_infos more">更多 ></div>
										</div>
									</div>
									<!-- 价格  优惠信息end -->
								</div>
								<div class="fs_pannel custom-scrollbar">
								<!-- 更多系列 start-->
								<template v-if='goodsDetail.data.goodsGroupList&&goodsDetail.data.goodsGroupList.length>0'>
									<div class="common_title minBox">更多系列</div>
									<div class="spec_list flex_row_center_center">
										<div class="spec_value flex_row_center_center " :class="{'selected':spu_item.goodsId==goodsDetail.data.goodsId}"
										@click="onSpuGroupClick(spu_item)" 	
										 v-for="(spu_item,spu_index) in goodsDetail.data.goodsGroupList" :key="spu_index" >
											<div class="spec_content overflow_ellipsis_two">{{spu_item.goodsDisplayName}}</div>										
										</div>
									</div>
								</template>	
								<!-- 更多系列 end-->	
								<!-- 选择配置start -->
								<template v-if='goodsDetail.data.productSpecs&&goodsDetail.data.productSpecs.length>0'>
									<div class="common_title minBox_normal" :class="{'minBox':!goodsDetail.data.goodsGroupList||goodsDetail.data.goodsGroupList.length==0}">选择配置</div>
									<div class="spec_list flex_row_center_center">
										<!-- <div class="spec_value flex_row_center_center " :class="{'disable':spec_item.stock==0,'selected':curSpecIndex==spec_index}" -->
										<div class="spec_value flex_row_center_center " :class="{'selected':curSpecIndex==spec_index}"
										@click="selectSpecVal(spec_item,spec_index)" 	
										 v-for="(spec_item,spec_index) in goodsDetail.data.productSpecs" :key="spec_index" >
											<div class="spec_content overflow_ellipsis_two">{{spec_item.specValues}}</div>										
										</div>
									</div>
									
								</template>	
								<!-- 选择配置end -->
								<!-- 增值服务start -->
								<template v-if='incrServiceInfo.data.length>0'>
									<div v-for="(sev_group_item,sev_group_index ) in incrServiceInfo.data" :key="sev_group_index">
										<div class="sev_content_title minSevBox flex_row_between_center" :class="{ noFirst:sev_group_index>0}">
											<div class="title">{{sev_group_item.increaseGroupName}}</div>
											<div class="learn_more" @click="onIncrSerDetailTap(sev_group_item.commodityList[sev_group_item.selIndex])"  v-if="sev_group_item.selIndex>=0"  >
												了解服务详情>
											</div>								
										</div>
										<div class="sev_list flex_row_center_center">
											<div class="sev_item flex_row_center_center " :class="{active:sev_index==sev_group_item.selIndex}"  @click="onIncrServTap(sev_group_index,sev_index)" v-for="(sev_item,sev_index) in sev_group_item.commodityList" :key="sev_index" >
												<div class="sev_value overflow_ellipsis ">{{sev_item.productShortTitle}}</div>
												<div class="sev_price">¥{{sev_item.productActivityPrice}}</div>
												<div class="sev_marketPrice" v-if="sev_item.productPrice">¥{{sev_item.productPrice}}</div>
												<div class="sev_benifit flex_row_center_center" v-if='sev_item.interestPoint'>{{sev_item.interestPoint}}</div>
											</div>
										</div>
									</div>
								</template>								
								<!-- 增值服务end -->
								<!-- 购买数量start -->
								<div class="buy_num minBoxNum flex_row_start_center" v-if="platformSupport">
									<div  @click="editNum('reduce')" class='add_redue' :class="{ no_edit: currentSpecNum == 1 }">
										<div class="jian symbol">-</div>
									</div>
									<input type="number" v-model="currentSpecNum"  @input="editNum('edit', $event)" @blur="editNum('edit', $event)"
										cursor-spacing="0" :cursor="currentSpecNum.toString().length" maxlength="5" />
									<div @click="editNum('add')"  class='add_redue' :class="{ no_edit: noEdit }">
										<div class="add symbol">+</div>
									</div>
								</div>
								<!-- 购买数量end -->
								</div>

								<div class="minBox_no_tip" v-if="!platformSupport">
									抱歉，该商品仅支持在小程序购买
								</div>
								<!-- 	deal start -->
								<div class="minBox_deal flex_row_between_center">
									<div class="minBox_deal_btn" :class="{minBoxBtnShow:canShowBottomRBtn}">
											<!--商品已下架 start -->
											<div class="action_btn_group" :class="{disable:!platformSupport}" v-if="goodsDetail.data.state != 3">
												<div class="action_btn large_btn flex_row_center_center">{{
										       L['商品已下架']
										        }}</div>
											</div>
											<!--商品已下架 end -->
											<!--库存不足start -->
											<div class="action_btn_group" :class="{disable:!platformSupport}" v-else-if="
											  defaultProduct &&
											  defaultProduct.data.productStock == 0&&promotionType!=freeOrder
										  ">
												<div class="action_btn large_btn flex_row_center_center" @click="doStockHasTap">
													{{ L['到货通知'] }}
												</div>
											</div>
											<!--库存不足 end -->
										<!-- 0元预约 -->
										<template v-else-if="promotionType==freeOrder">											
											<div class="action_btn_group flex_row_center_center" :class="{disable:!platformSupport}" v-if="!freeOrderInfo.data.isBooking">
												<div class="action_btn large_btn flex_row_center_center" @click='onFreeOrderTap(freeOrderInfo.data.type)'>{{freeOrderInfo.data.type==1?
												L['开始提醒']: L['预约']
												}}</div>
											</div>
											<div class="action_btn_group flex_row_center_center" :class="{disable:!platformSupport}" v-else>
												<div class="action_btn large_btn hasDo flex_row_center_center">{{
												L['已预约']
												}}</div>
											</div>
										</template>
										<!-- 限时抢购 -->
										<template v-else-if="promotionType==flashSale">
											
											<div class="action_btn_group flashSale flex_row_center_center" :class="{disable:!platformSupport}">
												<template v-if="goodsDetail.data.canAddCart">
													<div class="cart_btn flex_row_center_center"  @click="addCart">
														<img class="cart_icon" src="@/assets/goods/cart_white_icon.png"/>
													</div>
													<div class="action_btn middle flex_row_center_center"  @click="goBuy">
														{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即抢购'] }}
													</div>
												</template>
												<div class="action_btn middle action_long flex_row_center_center" v-else  @click="goBuy">
													{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即抢购'] }}
												</div>
											</div>
										</template>
										<!-- 预售 -->
										<template v-else-if="promotionType==preSel">										
											<div class="action_btn_group" :class="{disable:!platformSupport}" v-if="preSelInfo.data.type==1">
												<div class="action_btn large_btn flex_row_center_center dj" v-if='!preSelInfo.data.isPay' @click="goBuy">
											        <div class="dj_title">支付定金</div>
													<div class="dj_num">定金 ¥ {{preSelInfo.data.firstMoney}}</div>
											    </div>
												<div class="action_btn large_btn flex_row_center_center hasDo" v-else>
													已支付定金
												</div>
											</div>
											<div class="action_btn_group" :class="{disable:!platformSupport}" v-else>
												<div class="action_btn large_btn flex_row_center_center" v-if='!preSelInfo.data.isPay' @click="showNoDoToast">
												   支付全款							
												</div>
												<div class="action_btn large_btn flex_row_center_center hasDo" v-else>
													已支付全款
												</div>
											</div>
										</template>	
										<!-- 首单专享 -->
										<template v-else-if="promotionType==firstVIP">					
											<div class="action_btn_group" >
												<div class="action_btn large_btn flex_row_center_center" @click="goBuy">
													立即购买
												</div>
											</div>
										</template>
										<!-- 正常商品 start -->
										<template v-else>
											<!--商品已下架 start -->
											<div class="action_btn_group" v-if="goodsDetail.data.state != 3">
												<div class="action_btn large_btn flex_row_center_center">{{
										       L['商品已下架']
										        }}</div>
											</div>
											<!--商品已下架 end -->
											<!--库存不足start -->
											<div class="action_btn_group" v-else-if="
											  defaultProduct &&
											  defaultProduct.data.productStock == 0
										  ">
												<div class="action_btn large_btn flex_row_center_center" @click="doStockHasTap">
													{{ L['到货通知'] }}
												</div>
											</div>
											<!--库存不足 end -->
											
											<div class="action_btn_group flex_row_center_center" v-else>
												<template v-if="goodsDetail.data.canAddCart">																			
													<div class="cart_btn  flex_row_center_center" @click="addCart">
														<img class="cart_icon" src="@/assets/goods/cart_icon.png"/>
													</div>
													<div class="action_btn middle flex_row_center_center"  @click="goBuy">
														{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即购买'] }}													
													</div>
												</template>	
												<div class="action_btn middle action_long flex_row_center_center" v-else  @click="goBuy">
													{{receivableCouponIds&&receivableCouponIds.data.length>0? L['领券购买']:L['立即购买'] }}													
												</div>						
											</div>											
										</template>										
									</div>
									<div class="minBox_deal_fc  flex_row_between_center">
										<div class="op_item_contanier  flex_row_start_center" @click="collectGoods">
											<img class="op_item_icon" v-if="goodsDetail.data.followGoods"  src="@/assets/goods/favatared.png"/>
											<img class="op_item_icon" v-else  src="@/assets/goods/favatar.png"/>											
											<div class="op_item_txt">收藏</div>
										</div>
										<div class="op_item_contanier flex_row_start_center" style="opacity: 0;">
											<img class="op_item_icon" src="@/assets/goods/check_sel.png"/>
											<div class="op_item_txt">添加对比</div>
										</div>
									</div>
								</div>
								<!-- 	deal end -->
							</div>
							
							<!-- 悬浮小框  end-->
							
						</div>
						<!-- 商品详细信息 end -->
					</div>
					<!-- 商品相关 end -->
					
					
					<!-- 各种信息的切换 start -->
					<div class="container" ref="container" id="container">						
						<!-- 商品详情 评价 商品服务   start-->
						<div class="goods_description">
							<div class="goods_description_tab">
								<div class="contain_content">
									<div class="goods_description_title flex_row_start_center">					
										<div class="cursor_pointer goods_tab_item" :class="{ description_active: goodsDesctionType == 'detail' }"
											@click="goodsDescType('detail')">{{ L['商品详情'] }}</div>
										<div class="cursor_pointer goods_tab_item" :class="{
											description_active: goodsDesctionType == 'specParam'
										}" @click="goodsDescType('specParam')">{{ L['规格参数'] }}</div>
										<div class="cursor_pointer goods_tab_item comment" :class="{
											description_active: goodsDesctionType == 'evaluate'
										}" @click="goodsDescType('evaluate')">
											 <div>{{ L['商品评价'] }}</div>
											 <div class="count">({{ goodsCommentsInfo.data &&
						goodsCommentsInfo.data.commentsCount > 0 ? goodsCommentsInfo.data.commentsCount : '0' }})
											</div>
										</div>
										<div class="cursor_pointer goods_tab_item" style="display: none;"  :class="{
											description_active: goodsDesctionType == 'service'
										}" @click="goodsDescType('service')">{{ L['商品服务'] }}</div>
										
									</div>				
								</div>	
							</div>			
							
							<div class="goods_description_con">
								<div class="goods_pannel">
									<!-- 商品详情,规格参数,及详情富文本 start-->
									<div class="goods_des_con" v-if="goodsDesctionType == 'detail'">
										<div v-if="goodsDetail.data.goodsDetails ||
											goodsDetail.data.bottomTemplateContent ||
											goodsDetail.data.topTemplateContent
											">
											
											<div v-if="goodsDetail.data.topTemplateContent != undefined &&
												goodsDetail.data.topTemplateContent" class="hot_area top_hot_area" >
												<img class="hot_area_bg" :src="goodsDetail.data.topTemplateContent.img" />
												<view class="hot_area_div" v-for="(hotItem,hotIndex) in goodsDetail.data.topTemplateContent.items" :key="hotIndex"
													:style="{top:hotItem.y / 710 * hotAreaWidth  + 'px',left:hotItem.x / 710 * hotAreaWidth + 'px',width:hotItem.width / 710 * hotAreaWidth + 'px',height:hotItem.height / 710*hotAreaWidth  + 'px'}"
													@click="onHotAreaView(hotItem)"
												>						
												</view>
											</div>
											<div v-if="goodsDetail.data.goodsDetails != undefined &&
												goodsDetail.data.goodsDetails
												" class="goods_html" :style="goodsDetail.data.goodsDetailsBg">
												<div class="goods_htmls" v-html="goodsDetail.data.goodsDetails">
												</div>
											</div>
											<div v-if="goodsDetail.data.bottomTemplateContent != undefined &&
												goodsDetail.data.bottomTemplateContent
												" class="hot_area bottom_hot_area">
												<img class="hot_area_bg" :src="goodsDetail.data.bottomTemplateContent.img" />
												<view class="hot_area_div" v-for="(hotItem,hotIndex) in goodsDetail.data.bottomTemplateContent.items" :key="hotIndex"
													:style="{top:hotItem.y / 710 * hotAreaWidth  + 'px',left:hotItem.x / 710 * hotAreaWidth + 'px',width:hotItem.width / 710 * hotAreaWidth + 'px',height:hotItem.height / 710*hotAreaWidth  + 'px'}"
													@click="onHotAreaView(hotItem)"
												>						
												</view>
											</div>
										</div>
										<div v-else>
											<SldCommonEmpty :tip="L['该商品暂无详情~']" totalWidth="800px" />
										</div>
									</div>
									<!-- 商品详情,规格参数,及详情富文本 end-->
									<!-- 商品评价 start -->
									<div class="goods_comments" v-if="goodsDesctionType == 'evaluate'">
											
										<SldCommonEmpty :tip="L['暂无商品评价~']" totalWidth="800px" />
									</div>								
									<!-- 商品评价 end -->
									<!-- 商品规格参数 start-->
									<div class="goods_spec_param" v-if="goodsDesctionType == 'specParam'">
										<div class="spGroup" v-for="(specParamsItem,specParamsIndex) in specParams.data" :key="specParamsIndex">
											<div class="spGroupName">{{ specParamsItem.attributeGroupName }}</div>	
											<div class="spDetail" v-for="(spDetailItem,spDetailIndex) in specParamsItem.attributeList" :key="spDetailIndex">
												<div class="spDetailName">{{ spDetailItem.attributeName }}</div>
												<div class="spDetailValue">{{ spDetailItem.attributeValue }}</div>
											</div>
										</div>
									</div>
									<!-- 商品规格参数end-->
									<!-- 商品服务 start -->
									<div class="goods_server_list" v-if="goodsDesctionType == 'service'">
										<div v-if="goodsDetail.data.serviceLabels &&
											goodsDetail.data.serviceLabels.length > 0
											">
											<div class="goods_server_pre" v-for="(serverItem, serverIndex) in goodsDetail.data
												.serviceLabels" :key="serverIndex">
												<div class="server_pre_top flex_row_start_center">
													<span class="server_pre_tips"></span>
													<span class="server_pre_name">{{
														serverItem.labelName
													}}</span>
												</div>
												<div class="server_pre_content">
													{{ serverItem.description }}
												</div>
											</div>
										</div>
										<div v-else>
											<SldCommonEmpty :tip="L['暂无商品服务~']" totalWidth="800px" />
										</div>
									</div>
									<!-- 商品服务 end -->
								</div>	
							</div>
						</div>
						<!-- 商品详情 评价 商品服务 店铺热销  end-->
					</div>
					<!--各种信息的切换 end -->
				</div>
				<!-- 商品主要信息 end -->
			</div>
			
			<KefuSlip class="side_menu" @goTop="goTop" :productId="productId" :showGotoTop="containCon" :style="sideStyle"></KefuSlip>
			
			<SldLoginModal :visibleFlag="loginModalVisibleFlag" @closeLoingModal="closeLoingModal" @refreshInfo="refreshInfo" />
			<el-dialog v-model="imgVisible" width="70%" lock-sroll="false">

				<div style="height:700px;">
					<img :src="imgSource" alt="" class="imgOpen" />
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import addrData from '@/assets/area.json'
import {
	reactive,
	getCurrentInstance,
	ref,
	onMounted,
	watch,
	computed
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElRate } from 'element-plus'
import { qrcanvas } from 'qrcanvas'
import StoreHeaderCat from '../store/StoreHeaderCat'
import CouponItem from '@/components/CouponItem'
import { useStore } from 'vuex'
import SldLoginModal from '../../components/loginModal'
import SldCommonEmpty from '../../components/SldCommonEmpty'
import KefuSlip from '../../components/KefuSlip'
export default {
	name: 'goods-detail',
	components: {
		ElRate,
		StoreHeaderCat,
		CouponItem,
		SldLoginModal,
		SldCommonEmpty,
		KefuSlip
	},
	setup() {
		const firstLoading = ref(true) //是否第一次加载
		const router = useRouter()
		const route = useRoute()
		const store = useStore()
		//add
		const hotAreaWidth=ref(908)
		const freeOrder=ref(107) //0元预约
		const preSel=ref(103) //预售
		const flashSale=ref(106) //限时抢购	
		const firstVIP=ref(501)//首单专享
		const counponAct=ref(402)//优惠券活动
		const giftAct=ref(403)//赠品活动
		const interestFreeAct=ref(405)//免息
		const incrPriceShopAct=ref(406)//加价购
		const incrServiceAct=ref(407)//增值服务
		const secInterval=ref(null)//活动倒计时定时器
		const actCountDownDay=ref('00') //活动倒计时 天
		const actCountDownHr=ref('00') //活动倒计时 时
		const actCountDownMin=ref('00') //活动倒计时 分
		const actCountDownSec=ref('00') //活动倒计时 秒	
		const promotionId=ref(0)//当前互斥类型的活动id
		const promotionType=ref(0)//当前互斥的活动类型（103-预售活动 106-限时抢购, 107-预约活动）
		const hasAct=ref(false)// 是否有互斥类型的活动	
		const freeOrderInfo= reactive({ data: {} })
		const flashSaleInfo=reactive({ data: {} })				
		const preSelInfo=reactive({ data: {} })
		const couponList=reactive({ data: [] }) //优惠券列表I	
		const noRecCouponNum=ref(0)//未领取的优券个数	
		const showCoupons=reactive({ data: [] })//与赠品一起显示的优惠券信息	
		const giftInfo=reactive({ data: {} })  //赠品信息	
		const interFreeShowList=reactive({ data: [] })//免息的显示信息
		const showReceivedPrice=ref(false)//没有活动时，是否显示预估到手价
		const incrServiceInfo=reactive({ data: {} })//增值服务
		const incrServiceHis=reactive({data: {    //保存先前的spec对应的增值服务 productid为key，代表具体的spec，值为该spec对应的增值服务
			// productId:[], //每组添加 selIndex：-1 没有 ，>=0有
		}})
		
		const incrPriceShopInfo=reactive({data: {
			/*seledNum:0,加价购已选数量
			saveNum:0,加价购已选的金额
			list:[],
			stubNum:0,
			*/
		}})//加价购信息 -- 推荐搭配信息
		
		const incrPriceShopHis=reactive({data: {    //保存先前的spec对应的推荐搭配 productid为key，代表具体的spec，值为该spec对应的推荐搭配
			/*productId:{
				seledNum:0,加价购已选数量
				saveNum:0,加价购省的金额
				list:[]
			})*/  //添加是否选中，选中数量字段 sel:0--未选中  1--选中  num:1,购买的数量
				
		}})
		
		const receivableCouponIds=reactive({data: [  //当前可领可用券，用于是显示立即购买还是领券购买
			//couponId  
		]})
		const ruleInfo=reactive({ data: {} })//促销活动规则
		const canShowBottomRBtn=ref(false)//能否显示最下面的立即购买和加购物车		
		const attributeParams=reactive({ data: [] })	
		const curSpecValue=ref('')//当前选中的spec
		const curSpecIndex=ref(0)//当前选中的Index
		const defaultProduct=reactive({ data: {} });
		const services=reactive({data:[
			'笔记本意外险',
			'享运费险',
			'享7天无忧退',
			'其他项目'
		]})
		const noEdit=ref(false)//不可编辑
		
	
		const floatMinBoxTransX=ref(0)// 悬浮小框距离左边的位置
		const floatMinBoxShow=ref(0)//悬浮小框是否显示   0--显示位置未到 -1 显示空间不够
		const sBoxH=ref(0);
		const needUpdateSBoxH=ref(false)//是否需要更新悬浮框的高度
		const curShowPicIndex=ref(0);//当前显示第一个图片的index
		const ShowPicMaxNum=ref(5) 

		//spec弹框特殊使用 start,为了spec切换时，价格显示平滑
		const specNoActPrice=ref(0);//非互斥活动时，显示的价格
		const specNoCouponReceivedPrice=reactive({ data: {} });//
		const specNoShowReceivedPrice=ref(false);
		//spec弹框特殊使用 end
		
		const platformSupport=ref(1);//平台是否支持
		//add end
		//move 		
		const goodsPictureList = ref(null) //商品图片列表
		const productId = ref('') //货品id
		const goodsDetail = reactive({ data: {} }) //商品详情数据
		const loginModalVisibleFlag = ref(false) //登录弹框是否显示，默认不显示
		const vid = ref(0) //店铺id
		const { proxy } = getCurrentInstance()
		const L = proxy.$getCurLanguage()		
		const specParams=reactive({ data: [] }) //商品规格参数
		const pictureBig = ref(null) //大图的信息
		const maskBox = ref(null) //遮罩盒子的信息
		const maskShow = ref(false) //遮罩是否显示
		const previewBox = ref(null) // 左侧主图元素信息
		const zoomBox = ref(null) //左侧主图的父元素的信息
		const defaultImage = ref('') //默认主图路径
		const currentDefaultImage = ref('0') //默认主图显示第一张
		const currentSpecNum = ref(1) //商品编辑数量，默认数量为1
		const incrServiceTotalNum=ref(0)
		//move end
		
			
		const imgVisible = ref(false)
		const imgSource = ref('')
		const imgIndex = ref(-1)
		
		const recommendeList = reactive({ data: [] }) //看了又看商品
		const storePopularList = reactive({ data: [] }) //店铺推荐及热门收藏
		const storePopularType = ref('recommend') //店铺推荐及热门收藏,默认显示店铺推荐
		const goodsDesctionType = ref('detail') //商品详情,评价,商品服务,店铺热销,默认显示商品详情
		const goodsCommentsInfo = reactive({ data: {} }) //商品评价信息
		const evaluationType = ref('') //商品评价类型,默认显示全部
		const recommendedList = reactive({ data: [] }) //店铺推荐列表
		const evaluationCurrent = ref(1) //评价列表默认第一页
		const evaluationPageSize = ref(5) //评价列表默认一页显示5条数据
		const salesCurrent = ref(1) //店铺热销列表默认一页
		const salesPageSize = ref(20) //店铺热销列表默认一页显示20条数据
		const recommendeData = reactive({ data: {} }) //店铺热销推荐数据
		const couponModel = ref(false) //优惠券弹框是否显示
		const cartListData = reactive({ data: store.state.cartListData }) //获取vux的store中的购物车数据
		
		const container = ref(null) // 商品详情页底部内容区
		const containerTop = ref(0) //商品详情页底部内容区的top值
		const containCon = ref(false) //固定内容区头部
		const fullDiscountModel = ref(false) //满优惠弹框是否显示
		//const goodsPictureList = ref(null) //商品图片列表
		const curCouponPage = ref(1) //当前为第一页优惠券
		const couponPageSize = ref(6) //优惠券默认一页显示6条数据
		const wxShareCode = ref(false) //微信分享二维码是否显示
		const parameterShow = ref(false) //规格参数查看是否查看全部，默认为否
		const score = ref(0) //好评率
		const colors = ref(['var(--color_main)', 'var(--color_main)', 'var(--color_main)']) //星星颜色
		const curAddr = ref(-1)
		const curAddrName = ref('')
		const addrIdx = ref(0)
		const otherAddrIdx = ref(0)
		const othTopIdx = reactive({
			0: 0,
			1: 0,
			2: 0
		})
		const otherTree = ref([
			addrData[othTopIdx['0']],
			addrData[othTopIdx['0']].children[othTopIdx['1']]
		])
		const othAddrDe = ref(addrData)
		const addrDialogVisible = ref(false)
		const logFlag = ref(store.state.loginFlag)
		
		// 促销活动信息
		const preSellInfo = reactive({ data: {} })
		const pinInfo = reactive({ data: {} })
		const seckillInfo = reactive({ data: {} })
		const ladderInfo = reactive({ data: {} })
		const address_list = reactive({ data: [] })
		const isShowQr = ref(false)
		const secInt = ref('')
		const sideStyle = ref('');
		const time = reactive({
			day: '00',
			hours: '00',
			minutes: '00',
			seconds: '00'
		})
		const judgeStock = computed(() => {
			return (
				goodsDetail.data.defaultProduct.productStock == 0 ||
				(JSON.stringify(preSellInfo.data) != '{}' &&
					preSellInfo.data.presellStock == 0) ||
				(JSON.stringify(pinInfo.data) != '{}' &&
					pinInfo.data.spellStock == 0) ||
				(JSON.stringify(seckillInfo.data) != '{}' &&
					seckillInfo.data.seckillStock == 0)
			)
		})
		const totalPrice= computed(() => {
			var pPrice=defaultProduct.data.productPrice*currentSpecNum.value;
			if(promotionType.value==flashSale.value){ //抢购
				pPrice=flashSaleInfo.data.flashSalePrice*currentSpecNum.value;
			}
			else if(promotionType.value==firstVIP.value){  //首单
				pPrice=defaultProduct.data.firstBuyPrice*currentSpecNum.value;
			}
			if(incrPriceShopInfo&&incrPriceShopInfo.data.saveNum){
				pPrice+=incrPriceShopInfo.data.saveNum
			}
			if(incrServiceInfo&&incrServiceInfo.data.length>0){
				pPrice+=incrServiceTotalNum.value
			}
			
			
			return pPrice;
		})
		watch(
			()=>store.state.loginFlag,
			(newValue,oldValue)=>{
				console.log('--detail watch logState change-',newValue)				
				// incrPriceShopHis.data={}
				// incrServiceHis.data={}
				getGoodsDetailDynamic(true)
			}
		)
		

		onMounted(() => {
			 //debugger	
			productId.value = route.query.productId		
			getInitDataStatic(route.query.productId)
			
			containerTop.value = offset(container.value).top
			window.addEventListener('scroll', scrollHandle) //绑定页面滚动事件
			window.addEventListener('click', () => {
				addrDialogVisible.value = false
			})
			updateWindowSize()
			window.addEventListener('resize', updateWindowSize);
			if (!logFlag.value) {
				addrIdx.value = 1
			}

			if(window.innerHeight > 570){
        let top = (window.innerHeight - 450) / 2
        sideStyle.value = 'top:' + top + 'px'
      } else{
        sideStyle.value = 'top:120px'
      }
		})
		
		const updateWindowSize=()=>{

			var aWidth = window.document.body.clientWidth;
			let diff=(aWidth-1336)/2
			floatMinBoxTransX.value=diff*-1;
			if(diff<0){
				floatMinBoxShow.value=-1;				
			}else{				
				floatMinBoxShow.value=containCon.value?1:0;
				getSBoxH()
			}
			
			
		}
		
		const getSBoxH=()=>{
			if(floatMinBoxShow.value>0){
				proxy.$nextTick(()=>{
					sBoxH.value=document.getElementById('float_sBox').offsetHeight
				})
			}else{
				needUpdateSBoxH.value=true;
			}
				
		}
			
	
		const scrollHandle = async e => {
			let elementScrollTop = e.srcElement.scrollingElement.scrollTop //获取页面滚动高度
			
			// console.log('-----elementScrollTop-------',elementScrollTop)
			// console.log(' offsetTop', document.getElementById('container').offsetTop)
			// console.log(' offsetHeight', document.getElementById('container').offsetHeight)
		
			if (
				document.getElementById('container') &&
				elementScrollTop >= document.getElementById('container').offsetTop
			) {
				
				
				
				//console.log('floatMinBoxShow.value-------',floatMinBoxShow.value)
				if(floatMinBoxShow.value==0){
					floatMinBoxShow.value=1
					if(!containCon.value||needUpdateSBoxH.value){
						needUpdateSBoxH.value=false;
						proxy.$nextTick(()=>{
						sBoxH.value=document.getElementById('float_sBox').offsetHeight
						//console.log('--sBoxH.value0000-------',sBoxH.value)
						})
					}
				}
				containCon.value = true
				// console.log('floatMinBoxShow.value-------',floatMinBoxShow.value)
				if(floatMinBoxShow.value>0){
					//var sBoxH=document.getElementById('float_sBox').offsetHeight
					var cH=document.getElementById('container').offsetHeight
					var diff=elementScrollTop-document.getElementById('container').offsetTop-cH+sBoxH.value+105;
					if(diff>0){
						floatMinBoxShow.value=0;						
					}
					// console.log('diff-------',diff)
					// console.log('sBoxH.value-------',sBoxH.value)
					
				}
				
			
				// await proxy.$nextTick()
				// getCode()

				// console.log(
				// 	goodsDetail.data.qrCodeImage,
				// 	'goodsDetail.data.qrCodeImage'
				// )

				// if (goodsDetail.data.qrCodeImage) {
				// 	handleQrImage(goodsDetail.data.qrCodeImage, 'top')
				// } else {
				// 	getBigcode(goodsDetail.data.shareLink, 'top')
				// }
			} else {
				//getBigcode(goodsDetail.data.shareLink)
				containCon.value = false
				if(floatMinBoxShow.value==1){
					floatMinBoxShow.value=0
				}
			}
		}

		// 点击播放视频
		const playV = () => {
			currentDefaultImage.value = -1
			defaultImage.value = ''
			maskShow.value = false
			videoEnd()
		}

		/*收藏统计*/
		const doFavStatics=()=>{			
			let p_status=1;   //0-否，1-是  
			if(defaultProduct.data.productStock == 0){
				p_status=0
			}
			var pId=promotionId.value?promotionId.value:'';
			if(promotionType.value==firstVIP.value){
				pId=''
			}
			var path=window.location.href.split('?')[0]
			let params={
				product_sn:productId.value,
				activity_id:pId,
				is_instock:p_status,				
				refer_path:'',
				page_path:path,
			}
			proxy.$drgStatEvent('amall_product_collect',params)
		}	
		/*领取优惠券*/
		const getCouponsStatics=(couponId,actId)=>{	
			var path=window.location.href.split('?')[0]		
			let params={
				coupons_id:couponId,
				activity_id:actId?actId:'',				
				refer_path:'',
				page_path:path,
			}
			proxy.$drgStatEvent('amall_get_coupons',params)
		}			
		/*浏览商品页统计*/
		const browseThePageStatics=(actId)=>{
			
			let prepage = ''
			let p_status=1;  //0-否，1-是  
			if(defaultProduct.data.productStock == 0){
				p_status=0
			}
			let params={
				product_sn:productId.value,
				activity_id:actId,
				is_instock:p_status,					
				refer_path:'',				
				refer_query:'',			
			}
			proxy.$drgStatEvent('amall_product_detail_view',params)
			
		}
		const addCartStatics=()=>{			
			let p_status=1;  //0-否，1-是 
			if(defaultProduct.data.productStock == 0){
				p_status=0
			}
			var pId=promotionId.value?promotionId.value:'';
			if(promotionType.value==firstVIP.value){
				pId=''
			}
			var path=window.location.href.split('?')[0]
			let params={
				product_sn:productId.value,
				activity_id:pId,
				is_instock:p_status,
				product_num:currentSpecNum.value,
				refer_path:'',
				refer_query:'',
				page_path:path,
			}
			proxy.$drgStatEvent('amall_add_to_cart',params)
		}			

		//获取商品详情数据
		const getInitDataStatic = proId => {
			let params = {
				productId: proId
			}
			proxy
				.$get('v3/goods/front/goods/details', params)
				.then(res => {
					//just for test
					//res=getTestDetial()

					if (res.state == 200) {
						doInit(res)
						proxy.$sldStatEvent({
							behaviorType: 'gpv',
							goodsId: goodsDetail.data.goodsId,
							storeId: vid.value
						})
					} else {
						ElMessage.error(res.msg)
					}
				})
				.then(() => {
					getGoodsDetailDynamic(false,true,true)
					//getRecommend()
					//getStorePopular()
					//getCouponList()
					//getFullDiscountList()
					//getEvaluation()
					addLog()
					//getAddressList()
					// if (goodsDetail.data.qrCodeImage) {
					// 	handleQrImage(goodsDetail.data.qrCodeImage)
					// } else {
					// 	getBigcode(goodsDetail.data.shareLink)
					// }
				})
		}
		const doInit=(res)=>{
				let lastTopTemplateContent=goodsDetail.data.topTemplateContent;
				let lastGoodsDetail=goodsDetail.data.goodsDetail;
				let lastBottomTemplateContent=goodsDetail.data.bottomTemplateContent;

				goodsDetail.data=res.data;
				goodsDetail.data.categoryPath = res.data.categoryPath.split(
					'->'
				)
				goodsDetail.data.categoryIdPath = [res.data.categoryId1, res.data.categoryId2, res.data.categoryId3]
				// document.title = res.data['goodsName']	
				document.title = ['华硕' + res.data['goodsName'] + '价格-图片-华硕官方商城']
				document.querySelector('meta[name="keywords"]').setAttribute('content','华硕' + res.data['goodsName'] + ',华硕' + res.data['goodsName'] + '价格,华硕' + res.data['goodsName'] + '图片,华硕官网商城')
				document.querySelector('meta[name="description"]').setAttribute('content','华硕' + res.data['goodsName'] + '官方渠道售卖！华硕商城提供最新款的' + res.data['goodsName'] + '的价格、参数配置、图片、功能、型号等信息。官方品质保证，欢迎选购！')
				// console.log('res.data............',res.data)
				
				if (goodsDetail.data.topTemplateContent) {							
					try{
						goodsDetail.data.topTemplateContent=JSON.parse(goodsDetail.data.topTemplateContent)
						
					}catch(e){}
					
				}else {
					goodsDetail.data.topTemplateContent=lastTopTemplateContent
				}
				
				if (goodsDetail.data.goodsDetails) {
					goodsDetail.data.goodsDetails = proxy.$quillEscapeToHtml(
						goodsDetail.data.goodsDetails
					)
					//处理背景样式
					if (
						goodsDetail.data.goodsDetails.indexOf(
							'<p style="display:none;" data-background="'
						) != -1
					) {
						let bg = goodsDetail.data.goodsDetails
							.split('<p style="display:none;" data-background="')[1]
							.split('">')[0]
						goodsDetail.data.goodsDetailsBg = bg
					}
				}else{
					goodsDetail.data.goodsDetails=lastGoodsDetail
				}
				if (goodsDetail.data.bottomTemplateContent) {
						
					try{
						goodsDetail.data.bottomTemplateContent =JSON.parse(goodsDetail.data.bottomTemplateContent)
					}catch(e){}
						
				}else{
					goodsDetail.data.bottomTemplateContent=lastBottomTemplateContent
				}	
				vid.value = res.data.storeInf.storeId
		}

		const getGoodsDetailDynamic = (forLoginStateChange,needStatics,spuChange) => {
			let params = {
				productId: productId.value
			}
			proxy
				.$get('v3/goods/front/goods/detailAll', params)
				.then(res => {

					//just for test
					//res=getTestDetial()
					//res.data.canAddCart=0;

					if (res.state == 200) {
						if(spuChange){
							doInit(res)
						}	
						// defaultImage.value = res.data.defaultProduct.goodsPics[0]
						let dynamicData = [
							'productAndGoodBindAttributeValueVoList',//商品SPU/SKU合并后得参数列表
							'frontGoodAdvertisement',
							"goodsBrief",								
							"productSpecs", //规格列表,新版商城取这个
							"goodsGroupList",	
							'goodsVideo',
							'defaultProduct',
							'deliverInfo',
							'effectSpecValueIds',
							'followGoods',
							'specs',
							'storeInf',
							'sales',
							'state',
							'shareLink',
							'shareImage',
							'isVirtualGoods',
							'canAddCart',	
						]
						dynamicData.forEach(item => {							
							if(item=='defaultProduct'){
								if(res.data["goodsVideoImage"]&&res.data["goodsVideo"]){
									if(!res.data[item].goodsPics){
										res.data[item].goodsPics=[]
									}
									res.data[item].goodsPics.unshift(res.data["goodsVideoImage"])
								}
							}else if(item=='productAndGoodBindAttributeValueVoList'){
								dealAttributeParams(res.data[item])
							}
							goodsDetail.data[item] = res.data[item]
							
						})
						defaultImage.value = res.data.defaultProduct.goodsPics[0]						
						curSpecValue.value=res.data.defaultProduct.getSpecValues;
						if(res.data.productSpecs){
							for(let i=0;i<res.data.productSpecs.length;i++){
								if(res.data.productSpecs[i].productId==res.data.defaultProduct.productId){
									curSpecIndex.value=i;
									break;
								}
							}
						}
						let couponList=res.data.defaultProduct.frontCartUnderCouponDTOList;
						let revTmp=[]
						let noRevNum=0;
						if(couponList){
							couponList.forEach(item=>{
								item.effectiveStartYMD=getDataYMD(item.effectiveStart)
								item.effectiveEndYMD=getDataYMD(item.effectiveEnd)
								if(item.receiveFlag==0){  //没有领取
									revTmp.push(item.couponId)
									noRevNum++;
								}									
								
							})
						}else{
							couponList=[]
						}						
						couponList.data=couponList;
						noRecCouponNum.value=noRevNum
						receivableCouponIds.data=revTmp;
						productId.value =res.data.defaultProduct.productId
						defaultProduct.data = res.data.defaultProduct //默认货品信息
						
						currentDefaultImage.value = 0
						curShowPicIndex.value=0;
						/*reset 变量*/
						var hasAct=false;	
						var hasCounponAct=false;
						var hasIncrPriceShopAct=false;
						var hasincrServiceAct=false;
						var hasGiftAct=false;
						var hasInterestFreeAct=false;
						var promotionList=res.data.defaultProduct.promotionList;
						var hasDO=false;
						if(forLoginStateChange){
							incrPriceShopHis.data={}
							incrServiceHis.data={}
						}
						if(secInterval.value){
							clearInterval(secInterval.value)
							secInterval.value=null
						}
						let promotionIdTemp=''	
						if(promotionList){
							var hasfirstVip=false;//是否有首单专享
							var len=promotionList.length;
							for(let i=0;i<len;i++){
								if(promotionList[i].promotionType==firstVIP.value){
									hasfirstVip=true;
									break;
								}
							}
							promotionList.forEach(item=>{									
								//互斥的
								if(!hasfirstVip&&item.promotionType==freeOrder.value){//预约
									hasAct=true;
									promotionIdTemp=item.promotionId
									getFreeOrder(item.promotionId,item.promotionType)
									
								}else if(!hasfirstVip&&item.promotionType==preSel.value){//预售
									hasAct=true;
									promotionIdTemp=item.promotionId
									/*调接口*/									
									getPreSell(item.promotionId,item.promotionType)
									
								}else if(!hasfirstVip&&item.promotionType==flashSale.value){//限时抢购
								
									hasAct=true;
									promotionIdTemp=item.promotionId									
									/*调接口*/									
									getFlashSale(item.promotionId,item.promotionType)
								}else if(item.promotionType==firstVIP.value){//首单专享
									//test  暂时这样，后面看后端接口
									hasAct=true;
									promotionId.value=item.promotionId;
									promotionType.value=item.promotionType;
									/*调接口*/
									platformSupport.value=1;
									canShowBottomRBtn.value=true;								
								}										
								
								/*非互斥的*/
								if(item.promotionType==counponAct.value){
									hasCounponAct=true;
									if(item.descriptionList){
										showCoupons.data=item.descriptionList;
									}else{
										showCoupons.data=[]
									}									
									
								}
								if(item.promotionType==giftAct.value){
									hasGiftAct=true;
									getGiftList(item.promotionId)
								}
								if(item.promotionType==interestFreeAct.value){//、免息
									hasInterestFreeAct=true;
									if(item.descriptionList){
										interFreeShowList.data=item.descriptionList;										
									}else{
										interFreeShowList.data=[]
									}
								}
								if(item.promotionType==incrPriceShopAct.value){
									hasIncrPriceShopAct=true;										
									if(incrPriceShopHis.data[productId.value]){
										/*已有历史,yong */
										incrPriceShopInfo.data=incrPriceShopHis.data[productId.value];
										
									}else{
										getIncrPriceShop(item.promotionId)										
									}
									
								}
								if(item.promotionType==incrServiceAct.value){
									hasincrServiceAct=true;
									if(incrServiceHis.data[productId.value]){
										/*已有历史,yong */
										incrServiceInfo.data=incrServiceHis.data[productId.value];
										getSBoxH();
										
									}else{
										getIncrService(item.promotionId)										
									}
									
								}
							})								
							
							
						}
						
						if(!hasAct&&hasCounponAct&&defaultProduct.data.frontGoodsCouponReceivedPriceDTO.receivedPrice){
							showReceivedPrice.value=true;
						}else{
							showReceivedPrice.value=false;
						}
						if(!hasAct){								
							resetPromotionInfo()
							setSpecShowPriceInfo()								
						}
						if(!hasCounponAct){
							couponList.data=[];
							showCoupons.data=[];
						}
						if(!hasInterestFreeAct){
							interFreeShowList.data=[]
						}
						if(!hasGiftAct){
							giftInfo.data=[];
						}
						if(!hasIncrPriceShopAct){
							incrPriceShopInfo.data={};
						}
						if(!hasincrServiceAct){
							incrServiceInfo.data=[];
							
						}						
						firstLoading.value = false
						if(needStatics){
							browseThePageStatics(promotionIdTemp)
						}
					}
					getSBoxH();
				})
				.then(() => {
					//getCode()
					if(spuChange){
						/**是否需要？ */
						if (goodsDetail.data.qrCodeImage) {
							handleQrImage(goodsDetail.data.qrCodeImage)
						} else {
							//getBigcode(goodsDetail.data.shareLink)
						}
					}
				})
		}
		
		/*dataStr 2024-10-08 00:00:00
		*/
		const getDataYMD=(dataStr)=>{
			if(dataStr){
				let arr = dataStr.trim().split(" ");
				//return arr[0].replace(/-/g, '.');
			}else{
				return ''
			}
		}

		const setSpecShowPriceInfo=()=>{
			specNoActPrice.value=defaultProduct.data.productPrice;
			specNoCouponReceivedPrice.data=defaultProduct.data.frontGoodsCouponReceivedPriceDTO;
			specNoShowReceivedPrice.value=showReceivedPrice.value;	
		}
		/*专指互斥的*/
		const resetPromotionInfo=()=>{
			canShowBottomRBtn.value=true;
			platformSupport.value=1;
			hasAct.value=false;
			promotionId.value=0;
			promotionType.value=0;
			freeOrderInfo.data={};
			flashSaleInfo.data={}
			preSelInfo.data={};
		}

		const getCountDownInfo=(countTime)=>{
			let day = parseInt(countTime / 60 / 60 / 24)
			let hours = parseInt((countTime / 60 / 60) % 24)
			let minutes = parseInt((countTime / 60) % 60)
			let seconds = parseInt(countTime % 60)
			actCountDownDay.value = day
			actCountDownHr.value = hours > 9 ? hours : '0' + hours
			actCountDownMin.value = minutes > 9 ? minutes : '0' + minutes
			actCountDownSec.value = seconds > 9 ? seconds : '0' + seconds
			
		}
		
		const getFreeOrder=(_promotionId,_promotionType)=>{
			let param={
				productId:productId.value,
				promotionId:_promotionId
			}
			proxy.$post('v3/promotion/front/booking/getPromotionInfo',param,'json').then((res)=>{				
				
				//just for test
				//res=getTestFreeOrder()	
							
				if(res.state==200){
					let result = res.data;
					result.promotionId=_promotionId;
					freeOrderInfo.data = result;
					/*定时器*/
						let countTime = 0							
						countTime = freeOrderInfo.data.countdownTime //剩余时间	秒
						if(countTime>0){
							getCountDownInfo(countTime)
							secInterval.value = setInterval(() => {
								if (countTime == 0) {
									//倒计时结束，清除倒计时								
									if(secInterval.value){
										clearInterval(secInterval.value)
										secInterval.value=null
									}								
									getGoodsDetailDynamic()
								} else {
									countTime--
									getCountDownInfo(countTime)
								}
							}, 1000)								
						}
						hasAct.value=true;					
						promotionId.value  =_promotionId;
						promotionType.value=_promotionType;
						platformSupport.value=res.data.platformSupport
					
						getRule(result.articleId)
						proxy.$nextTick(()=>{
							handleNoSupWxQrImg()
						})
						
					} else {
						ElMessage.error(res.msg)
						resetPromotionInfo()
						
					}
					canShowBottomRBtn.value=true;
					setSpecShowPriceInfo()
						
				
			})
			.catch(() => {
				//异常处理				
				resetPromotionInfo()
				setSpecShowPriceInfo()
			})
			// .finllay(()=>{
			// 	setSpecShowPriceInfo()
			// })
		}
		
		//获取预售商品详情
		const getPreSell=(_promotionId,_promotionType)=>{
			let param={
				productId:productId.value,
				promotionId:_promotionId
			}
			proxy.$post('v3/promotion/front/preSellActivity/getPromotionInfo',param,'json').then(res=>{				
				
				//just for test
				//res=getTestPreSell()
								
				if(res.state==200){
					let result = res.data;
					result.promotionId=_promotionId;
					preSelInfo.data = result;
					/*定时器*/
					let countTime = 0							
					countTime = preSelInfo.data.countdownTime //剩余时间	秒
					if(countTime>0){
						getCountDownInfo(countTime)
						secInterval.value = setInterval(() => {
							if (countTime == 0) {
								//倒计时结束，清除倒计时
								if(secInterval.value){
									clearInterval(secInterval.value)
									secInterval.value=null
								}								
								getGoodsDetailDynamic()
							} else {
								countTime--
								getCountDownInfo(countTime)
							}
						}, 1000)								
					}
					hasAct.value=true;
					promotionId.value=_promotionId;
					promotionType.value=_promotionType;
					platformSupport.value=res.data.platformSupport;
					getRule(result.articleId)
					proxy.$nextTick(()=>{
						handleNoSupWxQrImg()
					})
					
				} else {
					ElMessage.error(res.msg)
					resetPromotionInfo()
					
				}
				canShowBottomRBtn.value=true;
				setSpecShowPriceInfo()		
				
				
			})
			.catch((e) => {
				resetPromotionInfo()
				setSpecShowPriceInfo()
			})
			// .finllay(()=>{
			// 	setSpecShowPriceInfo()
			// })
			
			
		}
		
		//获取限时抢购商品详情
		const getFlashSale=(_promotionId,_promotionType)=>{
			let param={
				productId:productId.value,
				flashSaleId:_promotionId
			}
			proxy.$post('v3/promotion/front/flashSale/detail',param,'json').then(res=>{				
				
				//just for test
				//res=getTestFlashSale()
								
				if(res.state==200){
					let result = res.data;
					result.promotionId=_promotionId;
					flashSaleInfo.data = result;
					/*定时器*/
					let countTime = 0							
					countTime = flashSaleInfo.data.countdownTime //剩余时间	秒
					if(countTime>0){
						getCountDownInfo(countTime)
						secInterval.value = setInterval(() => {
							if (countTime == 0) {
								//倒计时结束，清除倒计时
								if(secInterval.value){
									clearInterval(secInterval.value)
									secInterval.value=null
								}								
								getGoodsDetailDynamic()
							} else {
								countTime--
								getCountDownInfo(countTime)
							}
						}, 1000)								
					}
					hasAct.value=true;
					promotionId.value=_promotionId;
					promotionType.value=_promotionType;
					platformSupport.value=res.data.platformSupport					
					getRule(result.articleId)
					proxy.$nextTick(()=>{
						handleNoSupWxQrImg()
					})
					
				} else {
					ElMessage.error(res.msg)
					resetPromotionInfo()
					
				}
				canShowBottomRBtn.value=true;
				setSpecShowPriceInfo()
				
			})
			.catch((e) => {
				//异常处理
				resetPromotionInfo()
				setSpecShowPriceInfo()
			})
			// .finally(()=>{
			// 	setSpecShowPriceInfo()
				
			// })
		}
		
		/*加价购--推荐搭配*/
		const getIncrPriceShop=(_promotionId,_promotionType)=>{
			let param={
				productId:productId.value,
				increasePriceShoppingId:_promotionId,
				storeId:vid.value
			}
			proxy.$post('v3/promotion/front/increasePriceShopping/commodityList',param,'json').then(res=>{				
				
				//just for test
				//res=getTestIncrPriceShop()
								
				if(res.state==200){
					let result = res.data;
					result.forEach((item, index) => {
						item.sel=0;
						item.num=1;
						item.noEdit=false;
					})
					incrPriceShopHis.data[productId.value]={
						seledNum:0,
						saveNum:0,
						list:result,
						stubNum:result.length%3>0?3-result.length%3:0

					};
					incrPriceShopInfo.data = incrPriceShopHis.data[productId.value];
						
				} else {
					ElMessage.error(res.msg)	
				}
				
				
			})
			
		}
		
		/*增值服务*/
		const getIncrService=(_promotionId)=>{
			let param={
				productId:productId.value,
				increaseServiceId:_promotionId,
				storeId:vid.value
			}
			proxy.$post('v3/promotion/front/increaseService/commodityList',param,'json').then(res=>{				
				
				//just for test
				//res=getTestIncrService()
								
				if(res.state==200){
					let result = res.data;
					result.forEach((item, index) => {
						item.selIndex=-1;								
					})
					incrServiceInfo.data = result;
					incrServiceHis.data[productId.value]=incrServiceInfo.data;	
					getSBoxH();				
						
				} else {
					ElMessage.error(res.msg)	
				}
				
				
			})
			
		}
		// 赠品
		const getGiftList=(_promotionId)=>{
			let param={
				productId:productId.value,
				giftId:_promotionId,
				
			}
			proxy.$post('v3/promotion/front/gift/commodityList',param,'json').then(res=>{				
				
				//just for test
				//res=getTestGiftList()
								
				if(res.state==200){					
					giftInfo.data = res.data 					
						
				} else {
					ElMessage.error(res.msg)	
				}				
			})
			
		}
		
		//得到活动rule信息
		const getRule=(articleId)=>{
			let param={
				articleId: articleId
			
			}
			proxy.$get('/v3/cms/front/article/articleDetail',param).then(res=>{				
				if(res.state==200){
					ruleInfo.data = res.data
					ruleInfo.data.content=ruleInfo.data.content
					  ? proxy.$quillEscapeToHtml(ruleInfo.data.content)
					  : ''	
					
				} else {
					ElMessage.error(res.msg)	
				}	
			})
			
		}
		
		/*进行提醒预约
		 type 1-提醒、2-预约
		*/
		const onFreeOrderTap=(type)=>{
			
			if(!platformSupport.value){
				return 
			}


			if (!store.state.loginFlag) {
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
				return
			}			
			
			let param={
				productId: productId.value,
				bookingId:freeOrderInfo.data.promotionId,
				type:type 
			
			}
			proxy.$post('v3/promotion/front/booking/bookingActivities',param,'json').then(res=>{				
				//just for test
				//res.state=200
				
				if(res.state==200){
					/*suc*/
					if(type==1){
						ElMessage.success("设置提醒成功")
					}else{
						
						ElMessage.success("预约成功")
						freeOrderInfo.data.isBooking=true
					}	
					
				} else {
					ElMessage.error(res.msg)	
				}	
			})
		}
		const onSpuGroupClick=(spu_item)=>{
			let pId=spu_item.defaultProductId;					
			if(pId==productId.value){					
				return;
			}
			/*do something*/
			productId.value=pId;
			currentSpecNum.value=1;
			getGoodsDetailDynamic(false,true,true)
		
		}
		/*
		 * @param {Object} specId 父级规格值
		 * @param {Object} specValueId   点击的当前的规格值
		 */
		const selectSpecVal=(specItem,selIndex)=>{
			// if(specItem.stock==0){
			// 	return;// 没有库存，不能进行选中
			// }
			productId.value=specItem.productId;
			getGoodsDetailDynamic(false,true,true)				
			currentSpecNum.value=1;
			curSpecIndex.value=selIndex;
			curSpecValue.value=specItem.specValues;
			
		}
		
		//去商品详情页
		const goGoodsDetail = (productId) => {
			proxy.$goGoodsDetail(productId);
		};
		const getincrServiceNum=()=>{
			var price=0;
			if(incrServiceInfo){
				incrServiceInfo.data.forEach(item=>{
					if(item.selIndex>=0){
						price+=item.commodityList[item.selIndex].productActivityPrice
						
					}
				})
			
			}
			return price
		}
		/*增值服务*/
		const onIncrServTap=(g_index,item_index)=>{
			var gInfo=incrServiceInfo.data[g_index];
			if(gInfo.selIndex==item_index){ //如果是已选中则非选中
				gInfo.selIndex=-1
			}else{
				gInfo.selIndex=item_index;
			}
			incrServiceTotalNum.value=getincrServiceNum()	
			
		}

		/*选中的增值服务详情*/
		const onIncrSerDetailTap=(info)=>{
			proxy.$goGoodsDetail(info.productId)
		}
		
		/*推荐搭配*/
		const onIncPriceShopTap=(index)=>{
			var incInfo=incrPriceShopInfo.data.list[index];
			let sel=incInfo.sel?0:1;
			incInfo.sel=sel;
			if(sel){ /**/
				incrPriceShopInfo.data.seledNum+=incInfo.num;
				incrPriceShopInfo.data.saveNum+=incInfo.productIncreasePrice*incInfo.num;		
			}else{
				incrPriceShopInfo.data.seledNum-=incInfo.num;
				incrPriceShopInfo.data.saveNum-=incInfo.productIncreasePrice*incInfo.num;	
				if(incrPriceShopInfo.data.seledNum<0){
					incrPriceShopInfo.data.seledNum=0;
				}		
				if(incrPriceShopInfo.data.saveNum<0){
					incrPriceShopInfo.data.saveNum=0;
				}
			}
			
		}

		const ontjdpContentTap=(info)=>{
			proxy.$goGoodsDetail(info.productId)
		}
		
		const getTjdpSelInfo=()=>{			
			var incInfos=incrPriceShopInfo.data.list;
			var selNum=0;
			var saveNum=0;
			incInfos.forEach(item=>{
				if(item.sel){
					selNum+=item.num;
					saveNum+=item.productIncreasePrice*item.num
				}
			})
			incrPriceShopInfo.data.seledNum=selNum
			incrPriceShopInfo.data.saveNum=saveNum
			
		}
		//规则中推荐配置编辑数量
		const tjdpEditNum=(index,type, e)=> {
			
			let reg = /\./g
			let reg0 = /0+\d/
			
			var info=incrPriceShopInfo.data.list[index]
			var oldNum=info.num;
			if (
				reg.test(info.num.toString()) ||
				info.num <= 0
			) {
				
					info.num = 1
					getTjdpSelInfo(info)
				
			}
			if (type == 'add') {					
				
				let limit=info.shoppingUpperLimit;
				info.num++
				if (info.num > limit) {
					info.num = limit
					if(!info.noEdit){
						//ElMessage.closeAll()
						ElMessage('超过活动限制最大购买数量')	
					}					
					info.noEdit = true
					
					
				}
				getTjdpSelInfo(info,oldNum)
				
			}else if (type == 'edit') {
			
				if (info.num == '' || info.num < 0) {
					
					info.num = 1
					getTjdpSelInfo(info,oldNum)
					return
				}
				
				let limit=info.shoppingUpperLimit;
				if (info.num > limit) {
					
					info.num =limit 
					getTjdpSelInfo(info,oldNum)
					if(!info.noEdit){
						//ElMessage.closeAll()
						ElMessage('超过活动限制最大购买数量')	
					}
					
					info.noEdit = true
					return
				} else {
					info.num =
						e && e.detail.value ? e.detail.value : info.num
					if (info.num == 0 || info.num < 0) {						
						info.num = 1
						getTjdpSelInfo(info,oldNum)							
						
						return
					} else {
						info.num = info.num
							.toString()
							.replace(/\D/g, '')					
							
							info.num = Number(info.num)
							getTjdpSelInfo(info,oldNum)							
							info.noEdit = false
						}
					}
					
			}else if (type == 'reduce') {
				if (info.num > 1) {
					info.num--
					info.noEdit = false
				} else {
					info.num = 1
				}
				getTjdpSelInfo(info,oldNum)
			}	
			
		}
		
		const getBuyLimit=()=>{
			
			if(flashSaleInfo.data&&flashSaleInfo.data.buyLimit){
				return flashSaleInfo.data.buyLimit;
			}
			if(preSelInfo.data&&preSelInfo.data.buyLimit){
				return preSelInfo.data.buyLimit;
			}
			if(defaultProduct.data&&defaultProduct.data.cumulativePurchasesLimit&&defaultProduct.data.cumulativePurchasesLimit!=-1){
				return defaultProduct.data.cumulativePurchasesLimit
			}
			
			return 99999999;
		}
		//编辑数量
		const editNum=(type, e)=>{
			
			let reg = /\./g
			let reg0 = /0+\d/
		
			if (
				reg.test(currentSpecNum.value.toString()) ||
				currentSpecNum.value <= 0
			) {
				
				currentSpecNum.value = 1
				
			}
			let limit=getBuyLimit();
			if (type == 'add') {
				currentSpecNum.value++
				if (currentSpecNum.value > limit) {
					currentSpecNum.value = limit
					
					if(!noEdit.value){
						/ElMessage.closeAll()/
						ElMessage('已达到购买上限')
					}
					
					noEdit.value = true
				}
			}else if (type == 'edit') {					
				
					if (currentSpecNum.value== '' || currentSpecNum.value < 0) {						
						currentSpecNum.value = 1
						return
					}					
				
					if (currentSpecNum.value > limit) {
						
						currentSpecNum.value =limit 
						if(!noEdit.value){
							//ElMessage.closeAll()
							ElMessage('已达到购买上限')
						}
						noEdit.value = true
						return
					} else {
						currentSpecNum.value =
							e && e.detail.value ? e.detail.value : currentSpecNum.value
						if (currentSpecNum.value == 0 || currentSpecNum.value < 0) {
							currentSpecNum.value = 1
							return
						} else {						
							currentSpecNum.value = currentSpecNum.value
								.toString()
								.replace(/\D/g, '')
							currentSpecNum.value = Number(currentSpecNum.value)
															
						}						
					}
				
			
			} else if (type == 'reduce') {
				if (currentSpecNum.value > 1) {
					currentSpecNum.value--
					noEdit.value = false
				} else {
					currentSpecNum.value = 1
				}
			}	
			
		}
		//加入购物车功能
		const addCart=()=>{
			
			if(!platformSupport.value){
				return 
			}
			if (!store.state.loginFlag) {
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
				return
			}	
			
			var increments=[]
			var priceIncreasePurchase=[]
			if(incrServiceInfo){
				incrServiceInfo.data.forEach((item)=>{
					if(item.selIndex>=0){
						increments.push({
							buyNum:1,
							productId:item.commodityList[item.selIndex].productId
						})
					}
				})
			}
			if(incrPriceShopInfo&&incrPriceShopInfo.data.list){
				incrPriceShopInfo.data.list.forEach((item)=>{
					if(item.sel){
						priceIncreasePurchase.push({
							buyNum:item.num,
							productId:item.productId
						})
					}
				})
			}
			let param={
				productId: productId.value,
				buyNum: currentSpecNum.value,
				increments:increments,
				priceIncreasePurchase:priceIncreasePurchase,
			
			}
			proxy.$post('v3/business/front/cart/add',param,'json').then(res=>{	
				if (res.state == 200) {
					//更新购物车数量					
					proxy.$sldStatEvent({
						behaviorType: 'cart',
						goodsId: goodsDetail.data.goodsId,
						storeId: vid.value
					})
					ElMessage.success(res.msg)					
					addCartStatics()
				} else {
					ElMessage.error(res.msg)
				}
			})
			
		}
		
		const goBuy=()=>{
			
			if(!platformSupport.value){
				return 
			}
			if (!store.state.loginFlag) {
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
				return
			} else {
				let price=defaultProduct.data.productPrice;
				
				if(promotionType.value==flashSale.value){ //限时抢购
					price=flashSaleInfo.data.flashSalePrice  
				}else if(promotionType.value==preSel.value){
					price=preSelInfo.data.presellPrice 
				}else if(promotionType.value==firstVIP.value){
					price=defaultProduct.data.firstBuyPrice  //test me 
				}
			
				let data = {
					isCart: false,
					orderFrom:1,
					productId: productId.value,
					number: currentSpecNum.value,						
					source: 1,
					productPrice: price
				}
				if(promotionType.value==flashSale.value||
					promotionType.value==preSel.value||
					promotionType.value==firstVIP.value
				){ // 限时抢购,预售,首单专享
				  data.promotionId=promotionId.value;
				  data.promotionType=promotionType.value;
				}
				if(receivableCouponIds.data.length>0&&
					promotionType.value!=preSel.value&&
					promotionType.value!=firstVIP.value){ //预售、首单专享没有领券购买){
					data.receivableCouponIds=receivableCouponIds.data
				}
				let incrementList=[]
				var increments=[]
				var priceIncreasePurchase=[]
				if(incrServiceInfo){
					incrServiceInfo.data.forEach((item)=>{
						if(item.selIndex>=0){
							increments.push({
								number:1,
								productId:item.commodityList[item.selIndex].productId,
								productPrice:item.commodityList[item.selIndex].productActivityPrice,
								promotionId:item.promotionId,
								promotionType:item.promotionType,
							})
						}
					})
				}
				if(incrPriceShopInfo&&incrPriceShopInfo.data.list){
					 incrPriceShopInfo.data.list.forEach((item)=>{
						if(item.sel){
							priceIncreasePurchase.push({
								number:item.num,
								productId:item.productId,
								productPrice:item.productIncreasePrice,
								promotionId:item.promotionId,
								promotionType:item.promotionType,
								
							})
						}
					})
				}
				if(increments.length>0){
					data.incrementList=increments;
				}
				if(priceIncreasePurchase.length>0){
					data.priceIncreasePurchaseList=priceIncreasePurchase;
				}		
				let param = data
				proxy.$post('v3/business/front/orderOperate/check',param,'json').then(res=>{				
					
					//just for test
					//res=getTestCheck()
					
					if (res.state == 200) {							
						
						if(data.receivableCouponIds){ //领券购买
							ElMessage(res.msg)						
							setTimeout(()=>{
								toConfirmOrder(data)
							},3000)
						}else{
							toConfirmOrder(data)
						}
						
					}else if(res.state==267){
						let exProList = res.data.productList
						let exState = res.data.state
						
						if(exState==5){
							ElMessage('抢购活动已经结束，请重新选择')
						}else if(exState==1||exState==2){
							ElMessage(exProList[0].goodsName+'商品已下架，请重新选择')
						}	
						else if(exState==3||exState==4){
							ElMessage(exProList[0].goodsName+'商品库存不足，请重新选择”')
						}
						
						else{
							ElMessage(res.data.stateValue)
						}
					
					} else {
						ElMessage(res.msg)
					}
				})
			}
		}
		const toConfirmOrder=(data)=>{
			//从这里跳转页面后置为1，从一个页面返回回来，将在onShow里调用getGoodsDetail
			
			let query = {
				orderType: 1,
				goodsId: goodsDetail.data.goodsId,
				productId: productId.value,
				numbers: currentSpecNum.value,
				ifcart: 2,
				productPrice:data.productPrice,								
				orderFrom:data.orderFrom,
				source:data.source,
				
			}
			
			if(data.promotionId){
				query.promotionId=data.promotionId
			}						
			if(data.promotionType){
				query.promotionType=data.promotionType
			}
			if(data.receivableCouponIds){
				query.receivableCouponIds=JSON.stringify(data.receivableCouponIds)
			}
			if(data.incrementList){
				query.incrementList=JSON.stringify(data.incrementList)
			}
			if(data.priceIncreasePurchaseList){
				query.priceIncreasePurchaseList=JSON.stringify(data.priceIncreasePurchaseList)
			}
			router.push({
				path: '/buy/confirm',
				query
			})
			localStorage.setItem('addressId', curAddr.value)
			
			
		}	
		
		
		const showNoDoToast=()=>{
			ElMessage('功能暂未实现，敬请期待')
			
		}

		
		//move
		//视频播放结束时触发
		const videoEnd = () => {
			proxy.$nextTick(() => {
				proxy.$refs.video.onended = () => {
					currentDefaultImage.value = 0
					defaultImage.value = goodsDetail.data.defaultProduct.goodsPics[0]
				}
			})
		}
		
		const closeVideo=()=>{
			currentDefaultImage.value = 0
			defaultImage.value = goodsDetail.data.defaultProduct.goodsPics[0]
		}
		
		
		
		const onAderView=(url)=>{
			//window.open(url, '_blank');
			if(!url){
				return
			}
			var advInfo = JSON.parse(url.replace(/&quot;/g, '"'));
			proxy.$diyNavTo(advInfo,true);
		}
		
		
		const onHotAreaView=(info)=>{
			
			if(!info){
				return
			}
			
			 proxy.$diyNavTo(info,true);
		}
		/*到货通知*/
		const doStockHasTap=()=>{
				
			//just for test
			// if(true){ //暂时屏蔽
			// 	showNoDoToast()
			// 	return
			// }
			if(!platformSupport.value){
				return 
			}
			if (store.state.loginFlag) {
				doSubcribe()
			}else{
				goToByPush("/login", {});
			}

			
			
		}

		const doSubcribe=()=>{
			let params = {
				productId: productId.value
			}
			proxy
				.$get('v3/goods/front/goods/stockSubscribe/subscribe', params)
				.then(res => {				

					if (res.state == 200) {
						ElMessage('订阅成功')
					} else {
						ElMessage.error(res.msg)
					}
				})
		}
		
		
		const handleQrImage = (qrCodeImage) => {
			if(!qrCodeImage){
				return
			}
			let img = document.createElement('img')
			img.src = `data:image/png;base64,${qrCodeImage}`
			img.width = 120
			img.height = 120

		
			if (document.getElementById('wx_buy_qrcode_contaner')) {
				document.getElementById('wx_buy_qrcode_contaner').innerHTML = ''
				document.getElementById('wx_buy_qrcode_contaner').appendChild(img)
			}
			
		}	

		const handleNoSupWxQrImg=()=>{
			let qrCodeImage=goodsDetail.data.qrCodeImage
			if(!qrCodeImage){
				return
			}
			let imgNo = document.createElement('img')
			imgNo.src = `data:image/png;base64,${qrCodeImage}`
			imgNo.width = 80
			imgNo.height = 80
	
			if (document.getElementById('wx_buy_no_support')) {
				document.getElementById('wx_buy_no_support').innerHTML = ''
				document.getElementById('wx_buy_no_support').appendChild(imgNo)
			}
		}

		const genQrcode = () => {
			if (judgeStock.value) {
				return
			}
			proxy.$nextTick(() => {
				let canvas
				if (goodsDetail.data.qrCodeImage) {
					canvas = document.createElement('img')
					canvas.src = `data:image/png;base64,${goodsDetail.data.qrCodeImage}`
					canvas.width = 135
					canvas.height = 135
				} else {
					canvas = qrcanvas({
						data: goodsDetail.data.shareLink, //二维码内容
						size: 125,
						colorDark: 'red'
					})
				}
				setTimeout(() => {
					document.getElementById('qrcodeAct').innerHTML = ''
					document.getElementById('qrcodeAct').appendChild(canvas)
				}, 10)
			})
		}

		

		const recomOffShop = reactive({ data: [] })
		const getRecom = () => {
			proxy
				.$get('v3/goods/front/goods/goodsList', {
					storeId: goodsDetail.data.categoryId1
				})
				.then(res => {
					if (res.state == 200) {
						let top = Math.floor(Math.random() * (res.data.list.length - 8)) + 8
						let end = top - 8
						recomOffShop.data = res.data.list
							.filter(
								item =>
									item.defaultProductId !=
									goodsDetail.data.defaultProduct.productId
							)
							.slice(end, top)
					}
				})
		}

		//添加足迹
		const addLog = () => {
			let params = {
				productId: productId.value
			}
			proxy.$post('v3/member/front/productLookLog/add', params).then(res => {
				if (res.state == 200) {
					console.log()
				}
			})
		}
		
		//获取二维码
		const getCode = () => {
			proxy.$nextTick(() => {
				let canvas = qrcanvas({
					data: L['下单'], //二维码内容
					size: 20,
					colorDark: 'red'
				})
				if (document.getElementById('qrcode')) {
					document.getElementById('qrcode').innerHTML = ''
					document.getElementById('qrcode').appendChild(canvas)
				}
				if (document.getElementById('qrcode1')) {
					document.getElementById('qrcode1').innerHTML = ''
					document.getElementById('qrcode1').appendChild(canvas)
				}
			})
		}

		//获取商品的shareLink二维码
		const getBigcode = (link, type) => {
			proxy.$nextTick(() => {
				let canvas = qrcanvas({
					data: link, //二维码内容
					size: 125,
					colorDark: 'red'
				})
				if (type == 'top') {
					if (document.getElementById('qrcodeBig1')) {
						document.getElementById('qrcodeBig1').innerHTML = ''
						document.getElementById('qrcodeBig1').appendChild(canvas)
					}
				} else {
					if (document.getElementById('qrcodeBig')) {
						document.getElementById('qrcodeBig').innerHTML = ''
						document.getElementById('qrcodeBig').appendChild(canvas)
					}
				}
			})
		}

		
		
		//关闭登录弹框
		const closeLoingModal = () => {
			loginModalVisibleFlag.value = false
		}

		

	
		//切换商品详情,评价,服务,热销
		const goodsDescType = type => {
			let containerTop=document.getElementById('container').offsetTop
			let elementScrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop //获取页面滚动高度
			if (containCon.value) {
				window.scrollTo({
					top: containerTop,
					behavior: 'smooth'
				})
			}

			if (type == '' || !type) {
				goodsDesctionType.value = 'detail'
			} else {
				goodsDesctionType.value = type
			}
			
		}

		//获取商品评价
		const getEvaluation = type => {
			if (!type) {
				evaluationType.value = ''
			} else {
				evaluationType.value = type
			}
			let params = {
				productId: productId.value,
				current: evaluationCurrent.value,
				pageSize: evaluationPageSize.value,
				type: evaluationType.value
			}
			proxy.$get('v3/goods/front/goods/comment', params).then(res => {
				if (res.state == 200) {
					let result = res.data
					goodsCommentsInfo.data = result
					score.value = Number(goodsCommentsInfo.data.avgScore)
					goodsCommentsInfo.data &&
						goodsCommentsInfo.data.list &&
						goodsCommentsInfo.data.list.length > 0 &&
						goodsCommentsInfo.data.list.map(commentsItem => {
							commentsItem.memberName =
								commentsItem.memberName.slice(0, 1) +
								'***' +
								commentsItem.memberName.slice(
									commentsItem.memberName.length - 1,
									commentsItem.memberName.length
								)
						})
				} else {
					ElMessage.error(res.msg)
				}
			})
		}
		//评价列表上一页
		const handlePrevCilickChange = () => {
			if (evaluationCurrent.value == 1) {
				evaluationCurrent.value = 1
			} else {
				evaluationCurrent.value--
			}
			getEvaluation(evaluationType.value)
		}
		//评价列表下一页
		const handleNextCilickChange = () => {
			if (evaluationCurrent.value >= goodsCommentsInfo.data.list.length) {
				evaluationCurrent.value = goodsCommentsInfo.data.list.length
			} else {
				evaluationCurrent.value++
			}
			getEvaluation(evaluationType.value)
		}
		//评价列表当前选择页
		const handleCurrentChange = val => {
			evaluationCurrent.value = val
			getEvaluation(evaluationType.value)
		}
		//获取热销店铺推荐
		const getSalestore = () => {
			let params = {
				storeId: goodsDetail.data.storeInf.storeId,
				sort: 7,
				pageSize: salesPageSize.value,
				current: salesCurrent.value
			}
			proxy.$get('v3/goods/front/goods/goodsList', params).then(res => {
				if (res.state == 200) {
					let result = res.data
					recommendeData.data = result
					recommendedList.data = result.list
					recommendedList.data.map(
						item => (item.goodsPrice = new Number(item.goodsPrice).toFixed(2))
					)
				} else {
					ElMessage.error(res.msg)
				}
			})
		}
		//店铺热销列表上一页
		const handlePrevCilickChangeSales = () => {
			if (evaluationCurrent.value == 1) {
				salesCurrent.value = 1
			} else {
				salesCurrent.value--
			}
			getSalestore()
		}
		//店铺热销列表下一页
		const handleNextCilickChangeSales = () => {
			if (salesCurrent.value >= goodsCommentsInfo.data.list.length) {
				salesCurrent.value = goodsCommentsInfo.data.list.length
			} else {
				salesCurrent.value++
			}
			getSalestore()
		}
		//店铺热销列表当前选择页
		const handleCurrentChangeSales = val => {
			salesCurrent.value = val
			getSalestore()
		}
		//关注店铺及取消关注
		const focusStore = () => {
			if (store.state.loginFlag) {
				//已登录
				let params = {
					storeIds: goodsDetail.data.storeInf.storeId,
					isCollect: !goodsDetail.data.storeInf.isFollowStore
				}
				proxy.$post('v3/member/front/followStore/edit', params).then(res => {
					if (res.state == 200) {
						goodsDetail.data.storeInf.isFollowStore = !goodsDetail.data.storeInf
							.isFollowStore
						proxy.$refs.headercat.storeData.info.isFollow = goodsDetail.data
							.storeInf.isFollowStore
							? 'true'
							: 'false'
						if (goodsDetail.data.storeInf.isFollowStore) {
							proxy.$sldStatEvent({
								behaviorType: 'fol',
								storeId: goodsDetail.data.storeInf.storeId
							})
						}
					}
				})
			} else {
				//未登录提示登录
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
			}
		}
		//商品收藏及取消收藏
		const collectGoods = () => {
			if (store.state.loginFlag) {
				//已登录
				let params = {
					productIds: productId.value,
					isCollect: !goodsDetail.data.followGoods
				}
				proxy.$post('v3/member/front/followProduct/edit', params).then(res => {
					if (res.state == 200) {
						goodsDetail.data.followGoods = !goodsDetail.data.followGoods
						if (goodsDetail.data.followGoods) {
							proxy.$sldStatEvent({
								behaviorType: 'fav',
								goodsId: goodsDetail.data.goodsId,
								storeId: goodsDetail.data.storeInf.storeId
							})
						}
						ElMessage(res.msg)
						if(goodsDetail.data.followGoods){
							doFavStatics()
						}
					} else {
						ElMessage.error(res.msg)
					}
				})
			} else {
				//未登录提示登录
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
			}
		}

		//打开优惠券弹框
		const openCouponModel = () => {
			couponModel.value = true
			getCouponList()
		}
		//上一页优惠券
		const handlePrevCilickChangeCoupon = () => {
			curCouponPage.value--
			getCouponList()
		}
		//下一页优惠券
		const handleNextCilickChangeCoupon = () => {
			curCouponPage.value++
			getCouponList()
		}
		//当前页数优惠券
		const handleCurrentChangeCoupon = () => {
			getCouponList()
		}
		//点击查看全部查看全部的商品规格参数
		const openParameter = () => {
			parameterShow.value = !parameterShow.value
		}

		//选择商品主图
		const selectDefaultImage = (goodsImgItem, goodsImgIndex) => {
			defaultImage.value = goodsImgItem
			currentDefaultImage.value = goodsImgIndex
		}

		//切换商品主图
		const switchDefaultImage = type => {
			let defaultImagelength = goodsDetail.data.defaultProduct.goodsPics.length
			if (type == 'left') {
				currentDefaultImage.value--
				if (currentDefaultImage.value <= 0) {
					currentDefaultImage.value = 0
				}
				defaultImage.value =
					goodsDetail.data.defaultProduct.goodsPics[currentDefaultImage.value]
				
				curShowPicIndex.value--;	
				if (curShowPicIndex.value <= 0) {
					curShowPicIndex.value = 0
				}
			} else {
				currentDefaultImage.value++
				
				if (currentDefaultImage.value >= defaultImagelength) {
					currentDefaultImage.value = defaultImagelength - 1
					
				}
				defaultImage.value =
					goodsDetail.data.defaultProduct.goodsPics[currentDefaultImage.value]
					
				curShowPicIndex.value++
				let diffNum=defaultImagelength-ShowPicMaxNum.value   //5 是能显示的最大数量
				if(curShowPicIndex.value>diffNum){
					curShowPicIndex.value--
				}
			}
			goodsPictureListsTop()
		}
		//图片列表的left移动的距离
		const goodsPictureListsTop = () => {
			//获取 goods_picture_list 的元素
			let goodsPictureLists = goodsPictureList.value
			let num=ShowPicMaxNum.value-1;
			//列表默认显示5张图片
			if (
				goodsDetail.data.defaultProduct.goodsPics.length > 5 &&
				currentDefaultImage.value >= 0
			) {
				/* 分析找规律：
					如果有8张图片，点击右键 最大可以向左移动的距离为 8 - 5既3张图，left移动的距离为 3 * - 66px; currentDefaultImage.value从0开始的
					其中：66px为每一个元素需要每次移动的距离 为图片的宽度与图片之间的间距的和
					currentDefaultImage.value == 4；goodsPictureLists.style.left = 0；
					currentDefaultImage.value == 5；goodsPictureLists.style.left = (5-4) (1) * -66px；
					currentDefaultImage.value == 6；goodsPictureLists.style.left = (5-2) (2) * -66px；
					currentDefaultImage.value == 7；goodsPictureLists.style.left = (5-3) (2) * -66px；
					 点击左键，最大可以向右移动的距离为 8 - 5 即3张
					 currentDefaultImage.value == 0；goodsPictureLists.style.left = 0；
					 currentDefaultImage.value == 1； goodsPictureLists.style.left = -66px；
					 currentDefaultImage.value == 2; goodsPictureLists.style.left = 2 * -66px；
					 currentDefaultImage.value == 3; goodsPictureLists.style.left = 3 * -66px；
				*/
				if (currentDefaultImage.value > num) {
					goodsPictureLists.style.top =
						(currentDefaultImage.value - num) * -85 + 'px'
				}
				if (
					currentDefaultImage.value <
					goodsDetail.data.defaultProduct.goodsPics.length - num
				) {
					goodsPictureLists.style.top = currentDefaultImage.value * -85 + 'px'
				}
			}
		}

		//获取元素距离父元素的顶部及左边的距离
		const offset = el => {
			let top = el.offsetTop
			let left = el.offsetLeft
			while (el.offsetParent) {
				el = el.offsetParent
				top += el.offsetTop
				left += el.offsetLeft
				
			}
			return {
				left: left,
				top: top
			}
		}

		//鼠标移动
		const move = e => {
		
			if (currentDefaultImage.value == -1) {
				return
			}

			//主图父元素的信息 宽，高
			let previewsBox = previewBox.value
			let previewBoxWidth = previewsBox.offsetWidth
			let previewBoxHeight = previewsBox.offsetHeight
			//主图父元素距离顶部的距离
			let previewsBoxLeft = offset(previewsBox).left
			let previewsBoxTop = offset(previewsBox).top

			// 遮罩盒子的信息宽，高
			let masksBox = maskBox.value
			let maskBoxWidth = masksBox.offsetWidth
			let maskBoxHeight = masksBox.offsetHeight
			//鼠标距离屏幕距离
			let moveX = e.clientX
			let moveY = e.clientY

			//获取左侧大图父元素的信息
			let zoomsBox = zoomBox.value
			let zoomBoxWidth = zoomsBox.offsetWidth
			let zoomBoxHeight = zoomsBox.offsetHeight

			// 获取大图元素的信息宽，高
			let pictureBigBox = pictureBig.value
			let pictureBigWidth = pictureBigBox.offsetWidth
			let pictureBigHeight = pictureBigBox.offsetHeight

			//获取滚动条的高度
			let scroll = document.documentElement.scrollTop || document.body.scrollTop

			//主图距离父元素的left及top值
			let left = moveX - previewsBoxLeft - maskBoxWidth / 2
			let top
			if (scroll > 0) {
				top = moveY - previewsBoxTop + scroll - maskBoxHeight / 2
			} else {
				top = moveY - previewsBoxTop - maskBoxHeight / 2
			}
			

			//移动限制最大宽度，及最大高度
			let maxWidth = previewBoxWidth - maskBoxWidth
			let maxHeight = previewBoxHeight - maskBoxHeight
			

			left = left < 0 ? 0 : left > maxWidth ? maxWidth : left
			top = top < 0 ? 0 : top > maxHeight ? maxHeight : top
			
			//比列
			let parcentX = left / maxWidth
			let parcentY = top / maxHeight

			//遮罩层的定位值
			maskBox.value.style.left = left + 'px'
			maskBox.value.style.top = top + 'px'

			//大图元素的定位值
			pictureBig.value.style.left =
				parcentX * (zoomBoxWidth - pictureBigWidth) + 'px'
			pictureBig.value.style.top =
				parcentY * (zoomBoxHeight - pictureBigHeight) + 'px'
			pictureBig.value.style.width =
				(previewBoxWidth / maskBoxWidth) * zoomBoxWidth + 'px'
			pictureBig.value.style.height =
				(previewBoxHeight / maskBoxHeight) * zoomBoxHeight + 'px'
		}
		//鼠标移出
		const out = () => {
			maskShow.value = false
		}

		//鼠标移入
		const enter = () => {
			if (currentDefaultImage.value == -1) {
				return
			}
			addrDialogVisible.value = false
			maskShow.value = true
		}

		const kefu = () => {
			if (store.state.loginFlag) {
				let chatInfo = {
					storeId: goodsDetail.data.storeInf.storeId,
					vendorAvatar: goodsDetail.data.storeInf.storeLogo,
					storeName: goodsDetail.data.storeInf.storeName,
					source: L['从商品详情页进入'],
					sourceType: 'goods',
					showData: {
						productId: goodsDetail.data.defaultProduct.productId,
						goodsName: goodsDetail.data.goodsName,
						goodsImage: goodsDetail.data.shareImage,
						productPrice: goodsDetail.data.defaultProduct.productPrice,
						goodsId: goodsDetail.data.goodsId
					}
				}
				store.commit('saveChatBaseInfo', chatInfo)

				let newWin = router.resolve({
					path: '/service',
					query: {
						vid: goodsDetail.data.storeInf.storeId
					}
				})

				window.open(newWin.href, '_blank')
			} else {
				//未登录提示登录
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
			}
		}

		//进入店铺
		const goStore = () => {
			let tarUrl = router.resolve({
				path: '/store/index',
				query: {
					vid: vid.value
				}
			})
			window.open(tarUrl.href, '_blank')
		}

		// 评论区查看图片
		const showImg = (index, img) => {
			imgSource.value = img
			imgIndex.value = index
			imgVisible.value = true
		}

		//分享
		const share = type => {
			let title = goodsDetail.data.goodsName //需要分享的标题,这里取商品名字
			let url = goodsDetail.data.shareLink //分享的地址，用户点击可以进入到该商品
			let content = goodsDetail.data.goodsBrief //自定义内容,这里取商品广告词
			let targetUrl = '' //跳转的url地址
			if (type == 'weixin') {
				wxShareCode.value = true
				//微信
				let canvas = qrcanvas({
					data: url, //二维码内容
					size: 100,
					colorDark: 'red'
				})
				let share_wx_qrcode = document.getElementById('share_wx_qrcode')
				if (
					wxShareCode.value &&
					share_wx_qrcode != null &&
					share_wx_qrcode != undefined
				) {
					document.getElementById('share_wx_qrcode').innerHTML = ''
					document.getElementById('share_wx_qrcode').appendChild(canvas)
				}
			} else if (type == 'qzone') {
				wxShareCode.value = false
				//QQ空间
				targetUrl =
					'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?title=' +
					encodeURIComponent(title) +
					'&desc=' +
					encodeURIComponent(content) +
					'&summary=' +
					encodeURIComponent(content) +
					'&url=' +
					encodeURIComponent(url)
				window.open(targetUrl, '_blank')
			} else if (type == 'sina') {
				wxShareCode.value = false
				//新浪微博
				targetUrl =
					'https://service.weibo.com/share/share.php?title=' +
					encodeURIComponent(content + '「' + title + '」' + L[' 点这里'] + url)
				window.open(targetUrl, '_blank')
			}
		}

		//获取地址列表
		const getAddressList = () => {
			proxy
				.$get('v3/member/front/memberAddress/list', {
					pageSize: 1000
				})
				.then(res => {
					if (res.state == 200) {
						if (res.data.list.length > 0) {
							address_list.data = res.data.list
							if (address_list.data.findIndex(i => i.isDefault == 1) > 0) {
								let index = address_list.data.findIndex(i => i.isDefault == 1)
								curAddrName.value =
									address_list.data[index].addressAll +
									'' +
									address_list.data[index].detailAddress
								curAddr.value = address_list.data[index].addressId
								regionCode.value = address_list.data[index].cityCode
							} else {
								curAddrName.value =
									address_list.data[0].addressAll +
									'' +
									address_list.data[0].detailAddress
								curAddr.value = address_list.data[0].addressId
								regionCode.value = address_list.data[0].cityCode
							}

							if (localStorage.getItem('addressId')) {
								let addressID = localStorage.getItem('addressId')
								if (res.data.list.filter(i => i.addressId == addressID)[0]) {
									let tmp = res.data.list.filter(
										i => i.addressId == addressID
									)[0]
									curAddr.value = tmp.addressId
									curAddrName.value = tmp.addressAll + '' + tmp.detailAddress
									regionCode.value = tmp.cityCode
								}
							}
						} else {
							curAddrName.value = ''
							addrIdx.value = 1
						}
					}
				})
		}

		//修改选择地址列表
		const changeAddr = e => {
			curAddr.value = e
			let tmp = address_list.data.filter(i => i.addressId == e)[0]
			curAddrName.value = tmp.addressAll + '' + tmp.detailAddress
			addrDialogVisible.value = false
			regionCode.value = tmp.cityCode
			getUserEx(regionCode.value)
		}

		// 选择其他地址的顶部选项
		const selRegion = index => {
			otherAddrIdx.value = index
			switch (index) {
				case 0: {
					othAddrDe.value = addrData
					break
				}
				case 1: {
					othAddrDe.value = addrData[othTopIdx['0']].children
					break
				}
				case 2: {
					othAddrDe.value =
						addrData[othTopIdx['0']].children[othTopIdx['1']].children
					break
				}
			}
			otherTree.value[otherAddrIdx.value] =
				othAddrDe.value[othTopIdx[otherAddrIdx.value]]
		}

		// 选择其他地址的顶部选项下的子选项
		const selRegionChild = (index, otherIdx) => {
			othTopIdx[otherIdx] = index
			otherTree.value[otherAddrIdx.value] = othAddrDe.value[othTopIdx[otherIdx]]
			if (
				othAddrDe.value[othTopIdx[otherAddrIdx.value]].children &&
				othAddrDe.value[othTopIdx[otherAddrIdx.value]].children.length
			) {
				otherTree.value.splice(otherAddrIdx.value + 1)
				othTopIdx[otherIdx + 1] = 0
				selRegion(otherAddrIdx.value + 1)
			} else {
				regionCode.value = otherTree.value[otherAddrIdx.value - 1].regionCode
				addrDialogVisible.value = false
				curAddrName.value = ''
				otherTree.value.map(i => {
					curAddrName.value += i.regionName
				})
				getUserEx(regionCode.value)
			}
		}

		//用于切换用户的地址，获取信运费等
		const getUserEx = (cityCode) => {

			if (!cityCode) {
				return
			}


			proxy
				.$get('v3/goods/front/goods/calculateExpress', {
					cityCode,
					productId: productId.value,
					num: currentSpecNum.value

				})
				.then(res => {
					if (res.state == 200) {
						goodsDetail.data.deliverInfo.expressFee = res.data.toFixed(2)
					}
				})
			if (addressId >= 0) {
				proxy
					.$post('v3/member/front/memberAddress/changeDefaultAddress', {
						addressId,
						isDefault: 1
					})
					.then(() => { })
					.catch(() => { })
			}
		}

		const refreshInfo = () => {
			//history.go(0)
			
		}

		const updateFllow = e => {
			goodsDetail.data.storeInf.isFollowStore = e.state == 'true' ? true : false
		}

		const dealAttributeParams=(rawSpecParams)=>{
			if(!rawSpecParams){
				return;
			}
			var curGroupName=''	
			var spItem=null;
			var aitem=null;
			specParams.data=[];
			rawSpecParams.forEach(item=>{
				if(!item){
					return;
				}
				if(!item.attributeValue){
					return;
				}
				aitem={
						'attributeName':item.attributeName,
						'attributeValue':item.attributeValue
					}
				if(item.attributeGroupName!=curGroupName){					
					curGroupName=item.attributeGroupName					
					spItem={}
					//spItem["attributeGroupName"]=curGroupName!='默认分组'?curGroupName:'';	
					spItem["attributeGroupName"]=curGroupName;					
					spItem['attributeList']=[]					
					spItem['attributeList'].push(aitem)
					
					specParams.data.push(spItem)

				}else{
					spItem['attributeList'].push(aitem)	
				}
			})
		}

		const getTestComment=()=>{
				return {
					"data": {
						"commentsCount": 600,
						"hasPicCount": 0,
						"highCount": 0,
						"highPercent": "80%",
						"list": [
							{
								"commentId": 10,
								"content": "机器非常漂亮，性能也不错需，是梦想中的十四英寸情机。物流包装都很奈斯，满意支持华硕支持华硕打发打发",
								"createTime": 0,
								"images": [									
									"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
									"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/84voRBP14B86PqToV5c.jpg?bindId=65",
									"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/hEEQOFFZfSipAdMGtrD.jpg?bindId=66",
								],
								"isHide":1,//("是否匿名评价：0否1是");
								"imgStr": "",
								"memberAvatar": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/WMgg2Q4dQRSs4t5Ialq.jpg?bindId=69",
								"memberId": 0,
								"memberName": "1234",
								"replyContent": "",
								"specValues": "",
								"star": 5,//评分(1到5)
								"videoStr": "",
								"videos": [
									"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcvideos/member/evaluateVideo/lKLYT7SBUYXW42dPEL1.mp4",
									"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcvideos/member/evaluateVideo/6fv2Y5XCNeKRsohBMSr.mp4"
								],
							}
						],
						"lowCount": 0,
						"middleCount": 0
					},
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			
			const getTestFreeOrder=()=>{
				return {
					"data": {
						"bookingName": "",
						"countdownTime": 600000,
						"articleId": 10,
						"endTime": "",
						"isBooking": false,//当前按钮是否预约：0-未预约，1-已预约
						"isShowPresalePrice": 1,//是否显示活动价格（0-显示待发布，1-显示活动价）
						"platformSupport": 1,//是否支持该平台:0-禁用；1-启用
						"platforms": [1],//生效平台:生效平台 1、pc；2、H5；3、APP; 4、微信小程序；5、支付宝小程序.Json格式存储[1,2,3,4,5]
						"productPrice": 2000,//商品原价
						"promotionPrice": 340,//活动价
						"startTime": "",
						"type": 1,//当前按钮类型：1-提醒、2-预约
						"priceType":1,//价格类型：1-预约价、2-到手价
						"isStart":1,//活动是否开始:1、开始，0、未开始"
					},
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestFlashSale=()=>{
				return{
					"data": {
						"countdownTime": 60000,
						buyLimit:2,//最大限购数量；0为不限购
						"articleCategoryId": 0,
						"articleId": 0,
						"bookingId": 0,
						"displayTitle": "",
						"endTime": "",
						"flashSaleId": 0,
						"flashSaleName": "",
						"flashSalePrice": 300,//抢购活动价
						"goodsId": 0,
						"platformSupport": 1,
						"platforms": [1,2,3,4,5],
						"productId": 0,
						"productPrice": 30000,
						"receivableCouponIds": [null],//商品可领取的优惠券ID列表
						"receivedCouponId": 28, //预估可使用的优惠券ID。null表示没有可用券
						"receivedDiscountAmount": 50,//预估优惠金额
						"receivedPrice": 25000,//预估到手价
						"startTime": "",
						"subtitle": "距离活动结束还剩6天12:23:44"//副标题：距离活动结束还剩xx天 xx时：xx分：xx秒
					},
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestPreSell=()=>{
				return {
					"data": {
						"countdownTime": 600000,
						buyLimit:0,//最大限购数量；0为不限购
						"articleCategoryId": 0,
						"articleId": 10,
						"balancePayType": 0,
						"bookingId": 0,
						"deliverTime": "2024-11-12 23:08:10",//开始发货时间
						"depositInflation": 0,
						"discountFinalPayment": 0,
						"endTime": "2024-10-12 21:10:10",//活动结束时间
						"firstMoney":50,//支付定金（全款预售不需要此项，定金预售需要）
						"isPay": 0,//是否支付定金/全款：0-未支付，1-已支付
						"platformSupport": 1,//是否支持该平台:0-禁用；1-启用
						"platforms": [1],//
						"presellActivityName": "",
						"presellPrice": 2800,//预售价
						"productPrice": 3000,//商品原价
						"receivableCouponIds": [],//商品可领取的优惠券ID列表
						"receivedCouponAmount": 50,//优惠券优惠金额
						"receivedCouponId": null,//预估可使用的优惠券ID。null表示没有可用券
						"receivedDiscountAmount": 40,//定金优惠
						"receivedPrice": 2400,  //预估到手价
						"remainEndTime": "",
						"remainStartTime": "2024-10-18 20:10:10",//支付尾款的开始时间
						"secondMoney": 0,
						"startTime": "",
						"storeId": 0,
						"subtitle": "距离活动结束还剩12:23:44",
						"type":2,//预售类型（1-定金预售，2-全款预售）
					},
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestIncrPriceShop=()=>{
				return {
					"data": [
						{
							"goodsId": 0,
							"goodsName": "天选游戏笔记本电脑天选游戏笔记本",
							'productShortTitle': "天选游戏笔记本电脑天选游戏笔记本天选游戏笔记本电脑天选游戏笔记本",
							"increasePriceShoppingCommodityId": 30,//加价购商品id
							"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"productCode": "",
							"productId": 10,
							"productIncreasePrice": 60,//商品加购价
							"productPrice": 80,//商品原价
							"savePrice": 20, //节约价格
							"shoppingUpperLimit": 10,//购买上限
							"specValues": "",
							"promotionId": 233,
							"promotionType": 406,
						},
						// {
						// 	"goodsId": 0,
						// 	"goodsName": "天选游戏笔记本",
						// 	'productShortTitle': "天选游戏笔记本",
						// 	"increasePriceShoppingCommodityId": 130,//加价购商品id
						// 	"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
						// 	"productCode": "",
						// 	"productId": 20,
						// 	"productIncreasePrice": 160,//商品加购价
						// 	"productPrice": 80,//商品原价
						// 	"savePrice": 20, //节约价格
						// 	"shoppingUpperLimit": 2,//购买上限
						// 	"specValues": "",
						// 	"promotionId": 234,
						// 	"promotionType": 406,
						// },
						// {
						// 	"goodsId": 0,
						// 	"goodsName": "天选游戏笔记本电脑天选游戏笔记本",
						// 	'productShortTitle': "天选游戏笔记本电脑天选游戏笔记本",
						// 	"increasePriceShoppingCommodityId": 30,//加价购商品id
						// 	"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
						// 	"productCode": "",
						// 	"productId": 10,
						// 	"productIncreasePrice": 60,//商品加购价
						// 	"productPrice": 80,//商品原价
						// 	"savePrice": 20, //节约价格
						// 	"shoppingUpperLimit": 10,//购买上限
						// 	"specValues": "",
						// 	"promotionId": 235,
						// 	"promotionType": 406,
						// },
						// {
						// 	"goodsId": 0,
						// 	"goodsName": "天选游戏笔记本",
						// 	'productShortTitle': "天选游戏笔记本电脑天选游戏笔记本",
						// 	"increasePriceShoppingCommodityId": 130,//加价购商品id
						// 	"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
						// 	"productCode": "",
						// 	"productId": 20,
						// 	"productIncreasePrice": 160,//商品加购价
						// 	"productPrice": 80,//商品原价
						// 	"savePrice": 20, //节约价格
						// 	"shoppingUpperLimit": 2,//购买上限
						// 	"specValues": "",
						// 	"promotionId": 236,
						// 	"promotionType": 406,
						// },
						
					],
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestIncrService=()=>{
				return {
					"data": [
						{
							"commodityList": [
								{
									"goodsId": 0,
									"goodsName": "3年全面保",
									'productShortTitle': "3年全面保年33年全面保年年全面保年全面保年全面保年全面保年全面保3年全面保年33年全面保年年全面保年全面保年全面保年全面保年全面保",
									"increaseGroupName": "",
									"increaseServiceCommodityId": 20,//	增值服务商品id
									"interestPoint": "强推！月销爆款",//	利益点
									"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
									"productActivityPrice": 490,//商品活动价
									"productCode": "",
									"productId": 1,
									"productPrice": 500,
									"shoppingUpperLimit": 10,//购买上限
									"specValues": "",
									
								},
								{
									"goodsId": 0,
									"goodsName": "3年整机保修",
									'productShortTitle': "3年整机保修",
									"increaseGroupName": "",
									"increaseServiceCommodityId": 20,//	增值服务商品id
									"interestPoint": "强推！月销爆款",//	利益点
									"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
									"productActivityPrice": 490,//商品活动价
									"productCode": "",
									"productId": 2,
									"productPrice": 500,
									"shoppingUpperLimit": 10,//购买上限
									"specValues": "",									
								},{
									"goodsId": 0,
									"goodsName": "3年整机保修",
									'productShortTitle': "3年整机保修",
									"increaseGroupName": "",
									"increaseServiceCommodityId": 20,//	增值服务商品id
									"interestPoint": "强推！月销爆款",//	利益点
									"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
									"productActivityPrice": 490,//商品活动价
									"productCode": "",
									"productId": 3,
									"productPrice": 500,
									"shoppingUpperLimit": 10,//购买上限
									"specValues": "",
								
								}
							],
							"increaseGroupName": "延长保修",
							"promotionId": 332,
							"promotionType": 407,
						},
						{
							"commodityList": [
								{
									"goodsId": 0,
									"goodsName": "新机开荒",
									'productShortTitle': "3新机开荒",
									"increaseGroupName": "",
									"increaseServiceCommodityId": 20,//	增值服务商品id
									"interestPoint": "强推！月销爆款",//	利益点
									"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
									"productActivityPrice": 490,//商品活动价
									"productCode": "",
									"productId": 11,
									"productPrice": 500,
									"shoppingUpperLimit": 10,//购买上限
									"specValues": "",								
								},
								{
									"goodsId": 0,
									"goodsName": "3年整机保修",
									'productShortTitle': "3年整机保修",
									"increaseGroupName": "",
									"increaseServiceCommodityId": 120,//	增值服务商品id
									"interestPoint": "强推！月销爆款",//	利益点
									"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
									"productActivityPrice": 490,//商品活动价
									"productCode": "",
									"productId": 12,
									"productPrice": 1500,
									"shoppingUpperLimit": 10,//购买上限
									"specValues": "",
									
								},
							],
							"increaseGroupName": "服务升级",
							"promotionId": 340,
							"promotionType": 407,
						}
					],
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestGiftList=()=>{
				return {
					"data": [
						{
							"giftGiveawayId": 0,
							"giftId": 0,
							"goodsId": 0,
							"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"goodsName": "价值500元定制鼠标  黑色x1，赠完即止赠完即止赠完即止",
							"productCode": "",
							"productId": 20,
							"productPrice": 0,
							"specValues": "黑色",
							"productShortTitle":'价值500元定制鼠标价值500元定制鼠标价值500元定制鼠标',
							 "count":1
						},
						{
							"giftGiveawayId": 0,
							"giftId": 0,
							"goodsId": 0,
							"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"goodsName": "价值500元定制鼠标  黑色x1",
							"productCode": "",
							"productId": 30,
							"productPrice": 0,
							"specValues": "黑红色",
							"productShortTitle":'价值500元定制鼠标',
							 "count":10
						},
					],
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestCouponList=()=>{
				return {
					"data": [
						{
							"couponId": 10,
							"couponName": "Rog的地方地方的dfdf大额券",
							"couponType": 1,//优惠方式(1-满减；2-满折扣；3-随机金额券-保留）
							"effectiveEnd": "2024-12-08 00:00:00",//
							"effectiveStart": "2024-11-09 00:00:00",//
							"limitQuota": 1000,//订单金额使用限制，超过quota后可用
							"limitReceiveType": 0,
							"publishValue": 20,//发行限制-优惠券具体值(满减金额:例如20元，满折扣：例如9.5折）
							"receiveFlag": 0,//领取标识（默认未领取） 1：已领取 0：未领取
							"content":"满40000元减30元券"
						},
						{
							"couponId": 20,
							"couponName": "9.5折",
							"couponType": 2,//优惠方式(1-满减；2-满折扣；3-随机金额券-保留）
							"effectiveEnd": "2024-12-08 00:00:00",//
							"effectiveStart": "2024-11-09 00:00:00",//
							"limitQuota": 2000,//订单金额使用限制，超过quota后可用
							"limitReceiveType": 0,
							"publishValue": 9.5,//发行限制-优惠券具体值(满减金额:例如20元，满折扣：例如9.5折）
							"receiveFlag": 0,//领取标识（默认未领取） 1：已领取 0：未领取
							"content":"满40000元减9.5折券"
						},
						{
							"couponId": 30,
							"couponName": "9.5折",
							"couponType": 2,//优惠方式(1-满减；2-满折扣；3-随机金额券-保留）
							"effectiveEnd": "2024-12-08 00:00:00",//
							"effectiveStart": "2024-11-09 00:00:00",//
							"limitQuota": 2000,//订单金额使用限制，超过quota后可用
							"limitReceiveType": 0,
							"publishValue": 9.5,//发行限制-优惠券具体值(满减金额:例如20元，满折扣：例如9.5折）
							"receiveFlag": 1,//领取标识（默认未领取） 1：已领取 0：未领取
							"content":"满40000元减9.5折券"
						},
						{
							"couponId": 40,
							"couponName": "9.5折",
							"couponType": 2,//优惠方式(1-满减；2-满折扣；3-随机金额券-保留）
							"effectiveEnd": "2024-12-08 00:00:00",//
							"effectiveStart": "2024-11-09 00:00:00",//
							"limitQuota": 2000,//订单金额使用限制，超过quota后可用
							"limitReceiveType": 0,
							"publishValue": 9.5,//发行限制-优惠券具体值(满减金额:例如20元，满折扣：例如9.5折）
							"receiveFlag": 1,//领取标识（默认未领取） 1：已领取 0：未领取
							"content":"满40000元减9.5折券"
						}
					],
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
			const getTestCheck=()=>{
				return  {
					"data":{
						"stateValue":"以下商品下架",
						"state":5,
						"productList":[{"image":"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/2eXwPq6lpSKTJGz3VpX.jpg?bindId=283?x-oss-process=image/resize,w_0,h_100","promotionType":406,"buyNum":1,"productId":200002090005,"specValues":"默认","goodsId":100002030004,"price":"150","cartId":null,"goodsName":"ROG月刃2 ACE 三模游戏鼠标 AimPoint Pro光学传感器 月耀白","promotionId":66}]},
						"msg":"成功",
						"state":267,
						"timestamp":1731485339363
					
					}
			}
			const getTestDetial=()=>{
			  return{
				"data": {
					"canAddCart":0,//
					"serviceLabels": null,
					"goodsId": 100001540002,
					"isVirtualGoods": 1,
					"shareImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
					"shareLink": "https://dev-mall-m.njsyue.com/standard/product/detail?productId=200001590002",
					"sales": "3226",
					"goodsSubtitle": "dddd",
					"topTemplateContent": JSON.stringify({
						"img":'https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64',
						"items":[
							{
								height:100,
								width:100,
								x:100,
								y:100,
								url_type:'draws',
								info:'',
								url:''
							},
							
						]
					}),
					"bottomTemplateContent": JSON.stringify({
						"img":'https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/4Qo3DMrjVRwqXXoU6Kw.jpg?bindId=148',
						"items":[
							{
								height:100,
								width:100,
								x:100,
								y:100,
								url_type:'keyword',
								info:'',
								url:'rog'
							},
							
						]
					}),
					"goodsGroupList": [
						{
							"defaultProductId": 325,
							"goodsDisplayName": "高能轻薄 - 无畏酷睿版高能轻薄 - 无畏酷睿版高能轻薄 - 无畏酷睿版",
							"goodsId": 0,
							"groupId": 0
						},
						{
							"defaultProductId": 200001590002,
							"goodsDisplayName": "高能轻薄 - 无畏酷睿版",
							"goodsId": 0,
							"groupId": 0
						},
						{
							"defaultProductId": 325,
							"goodsDisplayName": "高能轻薄 - 无畏酷睿版",
							"goodsId": 0,
							"groupId": 0
						}
					],
					"specs": [
						{
							"specId": 2,
							"specName": "配置",
							"specValueList": [
								{
									"image": null,
									"specValue": "i9-13900H 32G 1TB 2.5Ki9-13900H",
									"checkState": 1,
									"specValueId": 7
								},
								{
									"image": null,
									"specValue": "i9-13900H 16G 1TB 2.5K 冰川银",
									"checkState": 3,
									"specValueId": 8
								},
								{
									"image": null,
									"specValue": "Ultra7 32G 1TB 2.8K 冰川银",
									"checkState": 3,
									"specValueId": 9
								},
								{
									"image": null,
									"specValue": "Ultra7 32G 1TB 2.8K 夜空蓝 ",
									"checkState": 3,
									"specValueId": 10
								},
								{
									"image": null,
									"specValue": "Ultra9 32G 1TB 2.8K 冰川银",
									"checkState": 3,
									"specValueId": 11
								}
							]
						}
					],
					"integral": 1,
					"deliverInfo": {
						"transTime": null,
						"cityName": null,
						"expressFee": 0
					},
					"storeInf": {
						"isFollowStore": false,
						"serviceScore": "5",
						"deliverScore": "5",
						"storeLogo": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/logo/GaK2UPhPVHtyPwZmnJL.png",
						"isOwnStore": 1,
						"storeName": "ROG商城",
						"followNumber": 0,
						"storeId": 460003,
						"storeGradeName": "",
						"descriptionScore": "5"
					},
					"goodsVideoImage": null,
					"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
					"state": 3,
					"afterSaleService": 0,
					"goodsParameterList": [
						{
							"parameterId": 3,
							"parameterName": "分辨率",
							"parameterValue": "720P"
						},
						{
							"parameterId": 4,
							"parameterName": "显示比例",
							"parameterValue": "16：9"
						},
						{
							"parameterId": 5,
							"parameterName": "面板",
							"parameterValue": "TP"
						}
					],
					"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
					"frontGoodAdvertisement": {
						adName:'百度百度',
						adLink:'https://www.baidu.com/'
					},
					"effectSpecValueIds": [],
					"brandName": "",
					"goodsDetails": "&lt;p&gt;&lt;img src=\"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64\"/&gt;&lt;img src=\"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240625/10495450534810.png\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240620/10392297981019.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240625/16441510257501.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16545951995756.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052491025.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052491025.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052545255.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550052971001.jpg\"/&gt;&lt;img src=\"https://static.asus.com.cn/store/20240306/16550153485153.jpg\"/&gt;&lt;/p&gt;",
					"productAndGoodBindAttributeValueVoList": [
						{
							"attributeValue": "带Office 2016",
							"attributeName": "操作系统",
							"attributeGroupName": "默认分组"
						},
						{
							"attributeValue": "3TB7200+256GB",
							"attributeName": "选择硬盘",
							"attributeGroupName": "默认分组"
						},
						{
							"attributeValue": "32GB",
							"attributeName": "选择内存",
							"attributeGroupName": "默认分组"
						},
						{
							"attributeValue": "AMD A10-8700P",
							"attributeName": "处理器",
							"attributeGroupName": "CPU信息"
						}
					],
					"categoryPath": "轻薄笔记本->便携轻薄本->灵耀14",				
					"productSpecs": [
						{
							"mainImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"productId": 200001590002,
							"specValues": "i9-13900H 32G 1TB 2.5Ki9-13900H 32G 1TB 2.5Ki9-13900H 32G 1TB 2.5K ",
							"stock": 1,
							"productPrice": 6199.00
						},
						{
							"mainImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"productId": 200001590003,
							"specValues": "i9-13900H 16G 1TB 2.5K 冰川银",
							"stock": 1,
							"productPrice": 7499.00
						},
						{
							"mainImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"productId": 200001590004,
							"specValues": "Ultra7 32G 1TB 2.8K 冰川银",
							"stock": 1,
							"productPrice": 6999.00
						},
						{
							"mainImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"productId": 200001590005,
							"specValues": "Ultra7 32G 1TB 2.8K 夜空蓝 ",
							"stock": 1,
							"productPrice": 6999.00
						},
						{
							"mainImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"productId": 200001590006,
							"specValues": "Ultra9 32G 1TB 2.8K 冰川银",
							"stock": 0,
							"productPrice": 5899.00
						}
					],
					"defaultProduct": {
						'cumulativePurchasesLimit':3,
						"firstBuyPrice":1000,
						"marketPrice": 6799.00,
						"goodsPics": [
							"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64",
							"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/84voRBP14B86PqToV5c.jpg?bindId=65",
							"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/hEEQOFFZfSipAdMGtrD.jpg?bindId=66",
							"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/0FEqSdTbLjG7pJwl0G7.jpg?bindId=67",
							"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
							"https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/WMgg2Q4dQRSs4t5Ialq.jpg?bindId=69"
						],
						"frontGoodsCouponReceivedPriceDTO":{
							"receivedcouponId":23,
							"receivedDiscountAmount":1,
							"receivedPrice":null,
						},
						"frontCartUnderCouponDTOList": [    //可领可用优惠卷列表
							{
								"couponId": 10,	
								"receiveFlag":0,
							},
							{
								"couponId": 20,	
								"receiveFlag":0,
							}
						],
						"promotionList": [  //促销活动
							{
								"promotionGrade": null,
								"promotionName": null,
								"promotionType": 107,
								"descriptionList": null,
								"goodsPromotionId": null,
								"promotionId": 45,
							},
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": null,
							// 	"promotionType": 501,
							// 	"descriptionList": null,
							// 	"goodsPromotionId": null,
							// 	"promotionId": 45,
							// },
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": null,
							// 	"promotionType": 402,
							// 	"descriptionList": ['1000元优惠券','1000元优惠券','1000元优惠券'],
							// 	"goodsPromotionId": null,
							// 	"promotionId": 25,
							// },
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": null,
							// 	"promotionType": 403,
							// 	"descriptionList": null,
							// 	"goodsPromotionId": null,
							// 	"promotionId": 25,
							// },
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": null,
							// 	"promotionType": 406,
							// 	"descriptionList": null,
							// 	"goodsPromotionId": null,
							// 	"promotionId": 25,
							// },
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": null,
							// 	"promotionType": 407,
							// 	"descriptionList": null,
							// 	"goodsPromotionId": null,
							// 	"promotionId": 25,
							// },
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": null,
							// 	"promotionType": 405,
							// 	"descriptionList": [
							// 		'支付宝免息',
							// 		'支付宝免息',
							// 		'支付宝免息',
							// 	],
							// 	"goodsPromotionId": null,
							// 	"promotionId": 25,
							// }
						],
						"promotionType": null,
						"getSpecValueIds": "7",
						"productId": 200001590002,
						"productStock":0,
						"getSpecValues": "i9-13900H 32G 1TB 2.5K ",
						"productPrice": 6199.00,
						"promotionId": null,
						"actualSales": 2
					},
					"categoryId1": 286449,
					"categoryId2": 286458,
					"goodsVideo": null,
					"categoryId3": 286465,
					"followGoods": false,
					"brandId": 0,
					"qrCodeImage": "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"
				},
				"msg": "成功",
				"state": 200,
				"timestamp": 1727059547527
			}
		}

		const goToByPush =(type,param = {})  => {
			router.push({
				path: type,
				query: param
			});
		}
		
		const goTop = () =>{
			console.log("goTop=====")
			window.scrollTo({
				top: 0, // 滚动到页面顶部
				behavior: 'smooth' // 平滑滚动（可选）
			});
    }
		//暴露的变量及方法
		return {
			L,
			//add
			hotAreaWidth,
			freeOrder,
			preSel,
			flashSale,
			firstVIP,
			counponAct,
			giftAct,
			goToByPush,
			doStockHasTap,
			interestFreeAct,
			incrPriceShopAct,
			incrServiceAct,
			actCountDownDay,
			actCountDownHr,
			actCountDownMin,
			actCountDownSec,
			promotionId, 
			promotionType,
			hasAct,	
			freeOrderInfo,
			flashSaleInfo,		
			preSelInfo,
			couponList,	
			noRecCouponNum,
			showCoupons,
			giftInfo,	
			interFreeShowList,
			showReceivedPrice,
			incrServiceInfo,
			incrServiceHis,	
			incrPriceShopInfo,			
			incrPriceShopHis,			
			receivableCouponIds,
			ruleInfo,
			canShowBottomRBtn,
			platformSupport,
			attributeParams,	
			curSpecValue,
			curSpecIndex,
			defaultProduct,
			services,
			onIncrServTap,
			onIncrSerDetailTap,
			onIncPriceShopTap,
			ontjdpContentTap,
			tjdpEditNum,
			noEdit,
			onFreeOrderTap,
			
			showNoDoToast,
			floatMinBoxTransX,
			floatMinBoxShow,
			specParams,
			curShowPicIndex,
			ShowPicMaxNum,
			totalPrice,
			incrServiceTotalNum,
			closeVideo,
			specNoActPrice,//非互斥活动时，显示的价格
			specNoCouponReceivedPrice,
			specNoShowReceivedPrice,
			onSpuGroupClick,
			//add end
			//move 		
			goodsPictureList,
			productId,
			goodsDetail,
			loginModalVisibleFlag,
			goGoodsDetail,
			editNum,
			addCart,
			goBuy,
			onAderView,
			onHotAreaView,
			genQrcode,
			pictureBig,
			maskBox,
			previewBox,
			zoomBox,
			maskShow,
			defaultImage,
			currentDefaultImage,
			currentSpecNum,
			selectSpecVal,
			move,
			out,
			enter,		
			selectDefaultImage,
			switchDefaultImage,
			vid,
			
			
			//move end
			
			
			
			couponList,
			
			
			
			recommendeList,
		
			storePopularList,
			storePopularType,
			goodsDesctionType,
			goodsDescType,
			goodsCommentsInfo,
			evaluationType,
			getEvaluation,
			recommendedList,
			evaluationCurrent,
			evaluationPageSize,
			handlePrevCilickChange,
			handleNextCilickChange,
			handleCurrentChange,
			salesPageSize,
			salesCurrent,
			handlePrevCilickChangeSales,
			handleNextCilickChangeSales,
			handleCurrentChangeSales,
			focusStore,
			collectGoods,
			
			
			recommendeData,
			openCouponModel,
			couponModel,
			cartListData,
		
			closeLoingModal,
			firstLoading,
			container,
			containerTop,
			containCon,
			kefu,
		
			fullDiscountModel,
			goStore,
		
			handlePrevCilickChangeCoupon,
			handleNextCilickChangeCoupon,
			handleCurrentChangeCoupon,
			curCouponPage,
			couponPageSize,
			share,
			wxShareCode,
			openParameter,
			parameterShow,
			
			score,
			colors,
			imgVisible,
			showImg,
			imgSource,
			recomOffShop,
			preSellInfo,
			pinInfo,
			seckillInfo,
			time,
		
			ladderInfo,
			genQrcode,
			isShowQr,
			judgeStock,
			playV,
			address_list,
			curAddr,
			changeAddr,
			curAddrName,
			addrIdx,
			addrData,
			otherAddrIdx,
			otherTree,
			othAddrDe,
			othTopIdx,
			selRegion,
			selRegionChild,
			addrDialogVisible,
			logFlag,
			refreshInfo,
			updateFllow,
			goTop,
			sideStyle
			
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/iconfont.css';
@import '../../style/goodsDetail.scss';

.adver{
	margin-top: 10px;
	.adver_content{
		font-family: Microsoft YaHei,Microsoft YaHei ;
		font-weight: 400;
		font-size: 15px;
		color: #DF443B;
		line-height: 22px;
		margin-right: 10px;
	}
	.adver_view{
		font-family: Microsoft YaHei,Microsoft YaHei ;
		font-weight: 400;
		font-size: 15px;
		color: #888E98;
		line-height: 22px;
	}
}

.sld_goods_detail {
	.goods_htmls {
		::v-deep p {
			line-height: 20px;
		}
		::v-deep .ql-video {
			width: 525px;
			height: 315px;
		}
		::v-deep a {
			display: inline-block;
			margin: 5px auto;
			color: #0000ff;
			text-decoration: underline;
		}
		::v-deep table {
			border-collapse: collapse;
			padding: 0;
		}
		::v-deep td {
			border: 1px solid #ddd;
			padding: 5px 10px;
		}
		::v-deep th {
			border: 1px solid #ddd;
			padding: 5px 10px;
		}
		::v-deep ol {
			padding-left: 10px;
			::v-deep li{
				list-style: unset;
			}
		}
		::v-deep ul {
			padding-left: 10px;
			::v-deep li{
				list-style: unset;
			}
		}
	}
}



.imageBorder {
	position: relative;
	border: 1px solid #eee;
}

.goods_picture_big {
	border: 1px solid #eee;
}

.goods_spec_param{
	padding-top: 15px;
	
	.spGroup{
		font-size: 15px;
		font-family: Microsoft YaHei,Microsoft YaHei ;
		width: 908px;
		.spGroupName{
			height: 50px;
			background: #F2F2F2;			
			border: 1px solid #D6D4D4;
			border-top: 0;
			display: flex;
			align-items: center;
			padding-left: 40px;			
			font-weight: 600;
			font-size: 15px;
			color: rgba(0,0,0,0.7);
		}
		.spDetail{
			height: 50px;
			background: #FFFFFF;				
			border: 1px solid #D6D4D4;
			border-top: 0;
			display: flex;			
			.spDetailName{
				width: 260px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;				
				font-weight: 600;			
				color: #000000;
				border-right: 1px solid #D6D4D4;
			}
			.spDetailValue{
				flex:1;
				height: 100%;
				display: flex;
				align-items: center;
				padding-left: 41px;			
				font-weight: 500;			
				color: rgba(0,0,0,0.7);

			}	
		}
		&:first-child{
			.spGroupName{
				border-top: 1px solid #D6D4D4;
			}
				
		}
	}
}

.side_menu {
    position: fixed;
    top: calc(100vh - 676px);
    right: 30px;
    z-index: 999;

  }
</style>
